import React, {useEffect, useRef} from "react"
import ListSubheader from '@material-ui/core/ListSubheader';
import MenuItem from "@material-ui/core/MenuItem";
import NumberFormat from 'react-number-format';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import {Tooltip, withStyles} from "@material-ui/core";
import {ProjectSaveService} from "../services/ProjectSaveService";
import KnxGenerateProjectService from "../services/knx_ausstattung/GenerateProjectService";
import KonventionellGenerateProjectService from "../services/konventionell_ausstattung/GenerateProjectService";
import HomeGenerateProjectService from "../services/home_ausstattung/GenerateProjectService";
import products from "../data/products.json";
import products_nl from "../data/products_nl.json";
import products_en from "../data/products_en.json";
import products_es from "../data/products_es.json";
import products_it from "../data/products_it.json";
import products_at from "../data/products_at.json";
import products_fr from "../data/products_fr.json";
import GenerateProductList from "../services/GenerateProductListService";
import {GenerateImagePath} from "../services/GenerateImagePath";
import uarrh from "../images/arrow_up_hover.svg";
import darrh from "../images/arrow_down_hover.svg";
import matrix_files from "../data/home_dateinamen.json"
import matrix_files_en from "../data/home_dateinamen_en.json"
import matrix_files_es from "../data/home_dateinamen_es.json"
import matrix_files_fr from "../data/home_dateinamen_fr.json"
import matrix_files_it from "../data/home_dateinamen_it.json"
import matrix_files_at from "../data/home_dateinamen_at.json"
import matrix_files_nl from "../data/home_dateinamen_nl.json"
import initialProjectData from "../data/initialProjectData.json";
// import uarr from "../images/arrow_up.svg";
import {sha1} from 'crypto-hash';
import FilterIcon2 from "@material-ui/icons/Tune";
import {useTranslation} from "react-i18next";
import iIconActive from "../images/info_icon_active.svg";
import iIconBlue from "../images/info_icon_blue.svg";
import Popover from "@material-ui/core/Popover";
import CloseIcon from "@material-ui/icons/Close";
import Checkbox from "@material-ui/core/Checkbox";
// import downloadIcon from "../images/arrow_download.svg";
// import ReCAPTCHA from "react-google-recaptcha";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
// import {Transition} from "react-transition-group";
// import boerseImg from "../images/projektboerse.png";
import boerseImg from "../images/projektboerse_neu.png";
import boerseCircle from "../images/circle-outline.svg";
import boerseCircleCheck from "../images/checkmark-circle-outline.svg";
import boerseLogo from "../images/projektboese-logo-jung.svg";
import boerseLogo2 from "../images/groups/logo-pb.svg";
import boerseLogox from "../images/groups/x.svg";
import arrow_right from "../images/groups/arrow_right.svg";
import page2Checker from "../images/groups/page2-checker.svg";
import pb01 from "../images/groups/group1020.svg";
import pb02 from "../images/groups/group990.svg";
import pb03 from "../images/groups/group989.svg";
import pb04 from "../images/groups/group832.svg";
import iconStep1 from "../images/groups/icon_step1.svg";
import iconStep2 from "../images/groups/icon_step2.svg";
import iconStep3 from "../images/groups/icon_step3.svg";
import iconStep4 from "../images/groups/icon_step4.svg";
import arrow_down from "../images/groups/arrow_down.svg";
import stepDivider from "../images/groups/step_divider.svg";
import jungLogo from "../images/logo_light.svg";
import {ProjectBoerseService} from "../services/ProjektBoerseService";
import jungHomeLogo from "../images/jung_quelle_home.svg";
import jungKnxLogo from "../images/jung_quelle_knx.svg";
import jungSwitchLogo from "../images/jung_quelle_switch.svg";
import peopleImg from "../images/People.png";
import jungPMBanner from "../images/jung-projektmanager-banner.png";
export default function StepFiveComponent({
    project, updateProject, showProjectPrices, foerderungs, PriceBox, trackingObj, equipmentData2, equipmentData4,
    isKonventionell, isHome, isMyJung=false, jumpTo, isIFrame, setPrCode, prCode, lastSum, setLastSum,
    isOldUrl, sentCodes, setSentCodes, wasFiltered, setWasFiltered
}){
    const [selectedRoomFilter, setSelectedRoomFilter] = React.useState({});
    const [selectedProductFilter, setSelectedProductFilter] = React.useState(undefined);
    const [foerderung1, setFoerderung1] = React.useState(false);
    const [foerderung2, setFoerderung2] = React.useState(false);
    const [foerderung3, setFoerderung3] = React.useState(false);
    const [inClipboard, setInClipboard] = React.useState(false);
    const [isOpen, setIsOpen] = React.useState(false);
    const [isFunktionenOpen, setIsFunktionenOpen] = React.useState(false);
    const [loadingRoomBook, setLoadingRoomBook] = React.useState(false);
    const [loadingFunctions, setLoadingFunctions] = React.useState(false);
    const [planungsCode, setPlanungsCode] = React.useState(null);
    const [loadingCSV, setLoadingCSV] = React.useState(false);
    const [roomProductFilters, setRoomProductFilters] = React.useState([]);
    const [selectedRoomProductFilter, setSelectedRoomProductFilter] = React.useState(undefined);
    const [selectedFunctionCat, setSelectedFunctionCat] = React.useState(undefined);
    const funcImgUrl = "https://www.projekt14.de/austausch/quick_j/home/functions/";
    const [currentSha1, setCurrentSha1] = React.useState('');
    const [partnerForm, setPartnerForm] = React.useState(null);
    const {t, i18n} = useTranslation();
    const [showFoerderung, setShowFoerderung] = React.useState(false);
    const language = i18n.resolvedLanguage;
    const isProjektboerse = process.env.REACT_APP_PROJEKTBOERSE === true || process.env.REACT_APP_PROJEKTBOERSE === 'true';
    const showProjektboerse = isProjektboerse && (process.env.REACT_APP_SHOW_PROJEKTBOERSE === true || process.env.REACT_APP_SHOW_PROJEKTBOERSE === 'true');
    const showProjektmanager = process.env.REACT_APP_SHOW_PROJEKTBOERSE === true || process.env.REACT_APP_SHOW_PROJEKTBOERSE === 'true';
    const [token, setToken] = React.useState("");
    // const [refreshReCaptcha, setRefreshReCaptcha] = React.useState(false);
    const [emailTextarea, setEmailTextarea] = React.useState(t('app.step.konfigAnfrage.placeholder'));
    const [emailVorname, setEmailVorname] = React.useState('');
    const [emailNachname, setEmailNachname] = React.useState('');
    const [emailRufnummer, setEmailRufnummer] = React.useState('');
    const [emailEmail, setEmailEmail] = React.useState('');
    const [emailChecker, setEmailChecker] = React.useState(false);
    // const [isFiltering, setIsFiltering] = React.useState(false);
    const [sentDialogIsOpened, setSentDialogIsOpened] = React.useState(false);
    const [boerseOpen, setBoerseOpen] = React.useState(false);
    const [userInfoOpen, setUserInfoOpen] = React.useState(false);
    const [userInfoPage, setUserInfoPage] = React.useState(1);
    const [boersePage, setBoersePage] = React.useState(1);
    const [boerseElement, setBoerseElement] = React.useState(null);
    const [userInfoElement, setUserInfoElement] = React.useState(null);
    const [projektOrt, setProjektOrt] = React.useState(false);
    const [boerseDatum, setBoerseDatum] = React.useState('');
    const [userInfoDatum, setUserInfoDatum] = React.useState('');
    const [currentToken, setCurrentToken] = React.useState('');
    const [prname, setPrname] = React.useState(project.projectName);
    const [valueIsMyJung, setValueIsMyJung] = React.useState(false);
    const boerseRef = useRef(null);
    const userInfoRef = useRef(null);
    const percent_lang = [
        {lang: 'de', value: 0.19, plusValue: 1.19},
        {lang: 'nl', value: 0.21, plusValue: 1.21},
        {lang: 'at', value: 0.20, plusValue: 1.20},
        {lang: 'it', value: 0.19, plusValue: 1.19},
        {lang: 'fr', value: 0.19, plusValue: 1.19},
        {lang: 'en', value: 0.19, plusValue: 1.19},
        {lang: 'es', value: 0.21, plusValue: 1.21},
    ];
    let currentPercent = percent_lang.filter(i => i.lang === language)[0].value;
    if (!currentPercent) { currentPercent = percent_lang[0].value; console.log('percent defaultet to ', currentPercent)}
    console.log('currentPercent is', currentPercent)
    useEffect(() => {
        setBoerseElement(boerseRef.current);
        setUserInfoElement(userInfoRef.current);
        let d = new Date();
        setBoerseDatum(d.getDate() + '.' + d.getMonth() + '.' + d.getFullYear());
        setUserInfoDatum(d.getDate() + '.' + d.getMonth() + '.' + d.getFullYear());
    }, [boerseRef,userInfoRef]);
    let totals;
    let pCode = null;
    let pCodeInterval = 0;
    let pCodeIntervalElbridge = 0;
    let callFunction = '';
    console.log('isprojektboerse', isProjektboerse, 'showboerse', showProjektboerse)
    let isProduction = getDomain().indexOf('konfigurator.jung.de') >= 0;

    let products_de = false;
    try {
        products_de = require('../data/products_de.json');
        const first_product_artnr = products_de[0].Artikelnummer;
        console.log('products_de imported. First Artikelnummer', first_product_artnr);
    } catch (e) {
        products_de = products;
        console.log('products_de fallback to products.json');
    }

    // const setTokenFunc = (getToken) => {
    //     setToken(getToken);
    // };

    useEffect(() => {
        if (!isIFrame) { setTimeout(() => {document.body.style.overflow = 'unset'; }, 200); }
    }, [isIFrame]);
    if (valueIsMyJung || window.planerParams.isMyJung) { isMyJung = true; project.isMyJung = true; }
    async function getSha1(code = '') {
        const ending = "uO`}y.fS@&!n\\k";
        const value = code + '' + ending;
        const result = await sha1(value);
        setCurrentSha1(result);
    }
    function useProjectService(projectIn){
        if(project.generatedProject !== undefined){
            return project;
        }
        // console.log('calling generateprojectservice', language)
        switch(projectIn.projectType){
            case "knx":
                if (language === 'en') return KnxGenerateProjectService(projectIn, products_en, 'en');
                if (language === 'es') return KnxGenerateProjectService(projectIn, products_es, 'es');
                if (language === 'nl') return KnxGenerateProjectService(projectIn, products_nl, 'nl');
                if (language === 'fr') return KnxGenerateProjectService(projectIn, products_fr, 'fr');
                if (language === 'it') return KnxGenerateProjectService(projectIn, products_it, 'it');
                if (language === 'at') return KnxGenerateProjectService(projectIn, products_at, 'at');
                if (language === 'de') return KnxGenerateProjectService(projectIn, products_de, 'de');
                break;
            case "konventionell":
                if (language === 'en') return KonventionellGenerateProjectService(projectIn, products_en, 'en');
                if (language === 'es') return KonventionellGenerateProjectService(projectIn, products_es, 'es');
                if (language === 'nl') return KonventionellGenerateProjectService(projectIn, products_nl, 'nl');
                if (language === 'fr') return KonventionellGenerateProjectService(projectIn, products_fr, 'fr');
                if (language === 'it') return KonventionellGenerateProjectService(projectIn, products_it, 'it');
                if (language === 'at') return KonventionellGenerateProjectService(projectIn, products_at, 'at');
                if (language === 'de') return KonventionellGenerateProjectService(projectIn, products_de, 'de');
                break;
            case "home":
                if (language === 'en') return HomeGenerateProjectService(projectIn, products_en, 'en');
                if (language === 'es') return HomeGenerateProjectService(projectIn, products_es, 'es');
                if (language === 'nl') return HomeGenerateProjectService(projectIn, products_nl, 'nl');
                if (language === 'fr') return HomeGenerateProjectService(projectIn, products_fr, 'fr');
                if (language === 'it') return HomeGenerateProjectService(projectIn, products_it, 'it');
                if (language === 'at') return HomeGenerateProjectService(projectIn, products_at, 'at');
                if (language === 'de') return HomeGenerateProjectService(projectIn, products_de, 'de');
                break;
            default:
                return project;
        }
    }
    const currentProject = useProjectService(project);
    var productListAndFiltersAll = GenerateProductList(currentProject, undefined, undefined, roomProductFilters, selectedRoomProductFilter);
    var productListAndFilters = GenerateProductList(currentProject, selectedRoomFilter, selectedProductFilter, roomProductFilters, selectedRoomProductFilter);
    function calculatePrices(begProductList, all = false){
        let produktpreis = 0;
        let nettopreis = 0;
        let mwst = 0;
        let beg = 0;
        let gesamtsumme = 0;
        const productList = all ? productListAndFiltersAll.productList : productListAndFilters.productList;
        const mwstPercent = currentPercent; //percent_lang.filter(i => i.lang === language)[0].value;
        const mwstPercentPlus = percent_lang.filter(i => i.lang === language)[0].plusValue;

        productList.forEach( g => {
            console.log('parsing group', g)
            g.products.filter(i => i.Preis >= 0).forEach(p => {
                p.count = parseInt(p.count, 10) || 0;
                const pnetto = (p.Preis*p.count);
                nettopreis += pnetto;
                mwst += pnetto*mwstPercent;
                produktpreis = p.Preis*mwstPercentPlus;
                console.log('parsing group product', p,p.Preis, p.count, (p.Preis*p.count), produktpreis, mwstPercent)
                if(foerderung1 === true && foerderung2 === true && foerderung3 === true){
                    const product = begProductList.find(pl => pl.Artikelnummer.toString() === p.Artikelnummer.toString());
                    if(product['BEG-35'] === 1){
                        gesamtsumme += (produktpreis*p.count)*0.6;
                        beg += (produktpreis*p.count)*0.4;
                    }else if(product['BEG-20'] === 1 && product['BEG-35'] === 0){
                        gesamtsumme += (produktpreis*p.count)*0.75;
                        beg += (produktpreis*p.count)*0.25;
                    }else if(product['BEG-20'] === 0 && product['BEG-35'] === 0){
                        gesamtsumme += (produktpreis*p.count)*0.95;
                        beg += (produktpreis*p.count)*0.05;
                    }else{
                        gesamtsumme += produktpreis * p.count;
                    }
                }
                else if(foerderung1 === true && foerderung2 === false && foerderung3 === true){
                    const product = begProductList.find(pl => pl.Artikelnummer.toString() === p.Artikelnummer.toString());
                    if(product['BEG-20'] === 1){
                        gesamtsumme += (produktpreis*p.count)*0.85;
                        beg += (produktpreis*p.count)*0.15;
                    }else if(product['BEG-20'] === 0){
                        gesamtsumme += (produktpreis*p.count)*0.95;
                        beg += (produktpreis*p.count)*0.05;
                    }else{
                        gesamtsumme += produktpreis*p.count;
                    }
                }
                else if(foerderung1 === true && foerderung2 === true && foerderung3 === false){
                    const product = begProductList.find(pl => pl.Artikelnummer.toString() === p.Artikelnummer.toString());
                    if(product['BEG-35'] === 1){
                        gesamtsumme += (produktpreis*p.count)*0.65;
                        beg += (produktpreis*p.count)*0.35;
                    }else if(product['BEG-20'] === 1 && product['BEG-35'] === 0){
                        gesamtsumme += (produktpreis*p.count)*0.8;
                        beg += (produktpreis*p.count)*0.2;
                    }else{
                        gesamtsumme += produktpreis*p.count;
                    }
                }
                else if(foerderung1 === true && foerderung2 === false && foerderung3 === false){
                    const product = begProductList.find(pl => pl.Artikelnummer.toString() === p.Artikelnummer.toString());
                    if(
                        product['BEG-20'] === 1 &&
                        (
                            currentProject.projectType === 'knx'
                            || currentProject.projectType === 'easy'
                            || currentProject.projectType === 'home'
                        )
                    ){
                        gesamtsumme += (produktpreis * p.count)*0.85;
                        beg += (produktpreis*p.count)*0.15;
                    }else if(currentProject.projectType === 'konventionell'){
                        gesamtsumme += (produktpreis*p.count);
                    }else{
                        gesamtsumme += produktpreis*p.count;
                    }
                }
            })
        })

        nettopreis = nettopreis / 100;
        mwst = (((nettopreis * mwstPercentPlus) * (mwstPercent*100)) / (mwstPercentPlus*100));
        beg = beg / 100;
        gesamtsumme = gesamtsumme / 100;
        produktpreis = nettopreis * mwstPercentPlus;

        nettopreis = round(nettopreis);
        mwst = round(mwst);
        beg = round(beg);
        gesamtsumme = round(gesamtsumme);
        produktpreis = round(produktpreis);
        console.log('mwst', mwstPercent, mwstPercentPlus, 'netto', nettopreis, 'mwst', mwst, 'gesamtsumme', gesamtsumme)
        return [nettopreis, mwst, beg, gesamtsumme, produktpreis];
    }
    let currentProducts = products;
    switch (language) {
        case 'en': currentProducts = products_en; break;
        case 'es': currentProducts = products_es; break;
        case 'nl': currentProducts = products_nl; break;
        case 'fr': currentProducts = products_fr; break;
        case 'it': currentProducts = products_it; break;
        case 'at': currentProducts = products_at; break;
        default: currentProducts = products_de; break;
    }
    let calculatedValues = calculatePrices(currentProducts);
    console.log('calculatedValues', calculatedValues, 'currentProducts first', currentProducts[0])
    productListAndFiltersAll = {...productListAndFiltersAll, calculatedValues: calculatePrices(currentProducts, true)};
    function onOpenClose(e) {
        e.preventDefault(); e.stopPropagation();
        if (isOpen) {
            // console.log('scrollto')
            if ('parentIFrame' in window) {
                window.parentIFrame.scrollToOffset(0, 0);
            } else {
                window.scrollTo(0, 0);
            }
        }
        setIsOpen(!isOpen);
        // if ('parentIFrame' in window && !wasOpen) {
        //     jumpTo(e.pageY);
        // }
        return false;
    }
    function onFunktionenToggle() {
        setIsFunktionenOpen(!isFunktionenOpen);
    }
    function selectProductFilterValue(item, allRoomsItem = undefined){
        setWasFiltered(true);
        if (!allRoomsItem) { setSelectedProductFilter(item); return; }
        productListAndFilters = {
            ...productListAndFilters,
            roomFilterList: productListAndFilters.roomFilterList.map(rf => rf.rooms.map(roomFilter => {
                if (roomFilter.id !== allRoomsItem.key) { return roomFilter; }
                setSelectedProductFilter({
                    ...roomFilter,
                    productFilter: allRoomsItem.productFilter,
                });
                return {
                    ...roomFilter,
                    productFilter: allRoomsItem.productFilter,
                };
            }))
        };
        setRoomProductFilters(productListAndFilters.roomFilterList);
    }
    function selectRoomFilerValue(floor, room, prodFilter){
        setWasFiltered(true);
        if(floor !== undefined && room !== undefined) {
            if (selectedProductFilter && selectedProductFilter.id) { setSelectedProductFilter(undefined); }
            setSelectedRoomFilter({floor: floor.id, room: room.id});
        }else if (floor !== undefined && room === undefined){
            setSelectedRoomFilter({floor: floor.id});
        }else if (floor === undefined && room === 'all') {
            setSelectedRoomFilter({floor: 'all', room: 'all'});
            setSelectedRoomProductFilter(prodFilter);
        }else{
            setSelectedRoomFilter({floor: undefined, room: undefined});
        }
    }
    function generateRoomFilter(roomFilterList){
        const list = [];
        list.push(<MenuItem value="alle" key={"alle"} style={{fontSize: "inherit"}} className={"roomFilterRoomItem"} onClick={e => selectRoomFilerValue(undefined, undefined)}>{t('app.option.overview')}</MenuItem>)
        list.push(<MenuItem value="all" key={"all"} style={{fontSize: "inherit"}} className={"roomFilterRoomItem"} onClick={e => selectRoomFilerValue(undefined, 'all')}>{t('app.option.allRooms')}</MenuItem>)
        roomFilterList.forEach( f=>{
            list.push(<ListSubheader value={f.id} key={f.id} style={{fontSize:"inherit"}} className={"roomFilterFloorItem"}
                                     onClick={e => selectRoomFilerValue(f)}
            >{f.name}</ListSubheader>);
            f.rooms.forEach(r => list.push(
            <MenuItem value={r.id} key={r.id} style={{fontSize: "inherit"}} className={"roomFilterRoomItem"}
                      onClick={e => selectRoomFilerValue(f, r)}>
                <div dangerouslySetInnerHTML={{__html: r.name}}></div>
            </MenuItem>));
        });
        return list;
    }
    function generateProductFilter(catFilterList, allRoomsItem = undefined){
        const list = [];
        list.push(<MenuItem value={"productFilter-all"} key={"productFilter-all"} style={{fontSize: "inherit"}} className={"productFilterItem"} onClick={e => selectProductFilterValue(undefined)}>{t('app.option.allProducts')}</MenuItem>);
        catFilterList.forEach((item) =>
            list.push(<MenuItem value={"productFilter-" + item.id} key={"productFilter-" + item.id}
                                style={{fontSize: "inherit"}} className={"productFilterItem"}
                                onClick={e => selectProductFilterValue(item.id)}>{t('app.category.' + item.name)}</MenuItem>)
        );
        return list;
    }
    const ColorButton4 = withStyles((theme) => ({
        root: {
            color: "var(--weiss)",
            backgroundColor: "var(--blueColor)",
            '&:hover': {
                backgroundColor:"var(--blueColorHover)",
            },
            borderRadius: 0,
            height: "45px",
            lineHeight: "45px",
            fontSize: "inherit",
            textAlign: "center",
            padding: "10px",
            flex: 1,
            textTransform: "inherit"
        },
    }))(Button);
    const ColorButton4Disabled = withStyles((theme) => ({
        root: {
            color: "var(--weiss)",
            backgroundColor: "var(--textColor)",
            '&:hover': {
                backgroundColor:"var(--textColor)",
            },
            cursor: 'not-allowed',
            borderRadius: 0,
            height: "45px",
            lineHeight: "45px",
            fontSize: "inherit",
            textAlign: "center",
            padding: "10px",
            flex: 1,
            textTransform: "inherit"
        },
    }))(Button);
    const ColorButton41 = withStyles((theme) => ({
        root: {
            color: "var(--weiss)",
            backgroundColor: "var(--blueColor)",
            '&:hover': {
                backgroundColor:"var(--blueColorHover)",
            },
            borderRadius: 0,
            height: "45px",
            lineHeight: "15px",
            fontSize: "inherit",
            textAlign: "center",
            padding: "10px",
            flex: 1,
            textTransform: "inherit"
        },
    }))(Button);
    const ColorButton42 = withStyles((theme) => ({
        root: {
            color: "var(--blueColor)",
            backgroundColor: "var(--weiss)",
            '&:hover': {
                backgroundColor:"var(--blueColorHover)",
                color: "var(--weiss)",
            },
            borderRadius: '3px',
            height: "45px",
            lineHeight: "15px",
            fontSize: "inherit",
            textAlign: "center",
            padding: "10px",
            flex: 1,
            textTransform: "inherit"
        },
    }))(Button);

    function generateGroupList(productList = undefined, justWithProducts = false){
        console.log('project', project, 'isMyJung', isMyJung)
        let plist = [];
        const lst = productList || productListAndFilters.productList;
        const optional = productListAndFilters.optionalProducts;
        lst.forEach( g => {
           if(selectedProductFilter === undefined || selectedProductFilter === g.name) {
               plist.push(<div className={"group"} key={g.name}>
                   <div className={"groupHeader"} dangerouslySetInnerHTML={{ __html: t('app.category.' + g.name) }}></div>
                   {project.isMyJung ? <div className={"tableHeader row myjung " + language}>
                       <div className="col-6">
                           <div className={"row"}>
                               <div className={"col-1"} style={{maxWidth: "50px"}}></div>
                               <div className={"col-11"}>{t('app.table.productName')}</div>
                           </div>
                       </div>
                       <div className="col-2 phoneNoShow" style={{textAlign: "left"}}>{t('app.table.artNo')}</div>
                       <div className="col-2 phoneNoShow">{t('app.table.count')}</div>
                       <div className="col-2">{t(isMyJung ? 'app.table.rrp.myjung' : 'app.table.rrp')}</div>
                   </div> : <div className={"tableHeader row phone-first-column-big"}>
                       <div className="col-6">
                           <div className={"row"}>
                               <div className={"col-1"} style={{maxWidth: "50px"}}></div>
                               <div className={"col-11"}>{t('app.table.productName')}</div>
                           </div>
                       </div>
                       <div className="col-6" style={{textAlign: "right"}}>{t('app.table.count')}</div>
                   </div>}
                   <div className={"groupContent 353"}>
                       {
                           generateProduktListForGroup(g, productList, project.isMyJung)
                       }
                   </div>
               </div>)
           } else if (selectedProductFilter && selectedProductFilter.products) {
               if (!justWithProducts || (justWithProducts && g.products.length))
               plist.push(<div className={"group"} key={g.name}>
                   <div className={"groupHeader"} dangerouslySetInnerHTML={{ __html: g.name }}></div>
                   <div className={"groupContent 365"}>
                       {
                           generateProduktListForGroup(g, productList, project.isMyJung)
                       }
                   </div>
               </div>)
           }
        });
        let list2 = [];
        if (optional.length > 0) {
            list2.push(<div className={"border-bottom"} style={{paddingTop: '15px'}}>
                <div className={"section-title"} style={{marginBottom: '5px'}}>{t('app.csv.optional')}</div>
            </div>);
        }
        optional.forEach( g => {
           if(selectedProductFilter === undefined || selectedProductFilter === g.name) {
               list2.push(project.isMyJung ?
               <div className={"group"} key={g.name}>
                   <div className={"groupHeader"} dangerouslySetInnerHTML={{ __html: g.name }}></div>
                   <div className="tableHeader row">
                       <div className="col-6">
                           <div className={"row"}>
                               <div className={"col-1"} style={{maxWidth: "50px"}}></div>
                               <div className={"col-11"}>{t('app.table.productName')}</div>
                           </div>
                       </div>
                       <div className="col-2" style={{textAlign: "left"}}>{t('app.table.artNo')}</div>
                       <div className="col-2">{t('app.table.count')}</div>
                       <div className="col-2">{t(isMyJung ? 'app.table.rrp.myjung' : 'app.table.rrp')}</div>
                   </div>
                   <div className={"groupContent"}>
                       {
                           generateProduktListForGroupOptional(g, g.products)
                       }
                   </div>
               </div>
               :
               <div className={"group"} key={g.name}>
                   <div className={"groupHeader"} dangerouslySetInnerHTML={{ __html: g.name }}></div>
                   <div className="tableHeader row">
                       <div className="col-6">
                           <div className={"row"}>
                               <div className={"col-1"} style={{maxWidth: "50px"}}></div>
                               <div className={"col-11"}>{t('app.table.productName')}</div>
                           </div>
                       </div>
                       <div className="col-6" style={{textAlign: "right"}}>{t('app.table.count')}</div>
                   </div>
                   <div className={"groupContent"}>
                       {
                           generateProduktListForGroupOptional(g, g.products)
                       }
                   </div>
               </div>
               )
           } else if (selectedProductFilter && selectedProductFilter.products) {
               if (!justWithProducts || (justWithProducts && g.products.length))
               list2.push(<div className={"group"} key={g.name}>
                   <div className={"groupHeader"} dangerouslySetInnerHTML={{ __html: g.name }}></div>
                   <div className={"groupContent"}>
                       {
                           generateProduktListForGroupOptional(g, g.products)
                       }
                   </div>
               </div>)
           }
        });
        if (list2.length) {
            plist.push(<div className={"optional-products"}><>{list2}</></div>);
        }
        if (!plist.length) { plist.push(<div className={"row"} style={{margin: "15px 0"}}>{t('app.table.noProducts')}</div>); }
        return plist;
    }
    function generatePListForRoom(g) {
        const list = [];
        g.products.forEach(pr => {
            list.push(project.isMyJung ?
            <div className={"row bb-2 wpadding"} key={pr.Artikelnummer}>
                <div className="col-6" key={pr.Artikelnummer}>
                    <div className={"row"} style={{maxHeight: "50px"}}>
                        <div className={"col-1"} style={{minWidth: "50px", maxWidth: "50px"}}>
                            <img src={GenerateImagePath.getPath(pr.Gtin, "")} alt=""
                                 style={{maxWidth: "50px", maxHeight: "50px"}}/>
                        </div>
                        <div className={"col-11 productName"} style={{padding: "0 30px"}}>{pr.Bezeichnung}</div>
                    </div>
                </div>
                <div className={"col-2 artNr"}
                     style={{padding: "0 0px", textAlign: "left"}}>{pr.Artikelnummer}</div>
                <div className="text-right col-2">{pr.count}</div>
                <div className="text-right col-2">{pr.Preis >= 0 ? <NumberFormat value={(pr.Preis / 100) * pr.count}
                                                                displayType={'text'} suffix={" €"}
                                                                thousandSeparator={"."}
                                                                decimalScale={2}
                                                                fixedDecimalScale={true}
                                                                decimalSeparator={","}/> : "Ohne Angabe"}
                </div>
            </div> :
            <div className={"row bb-2 wpadding"} key={pr.Artikelnummer}>
                <div className="col-6" key={pr.Artikelnummer}>
                    <div className={"row"} style={{maxHeight: "50px"}}>
                        <div className={"col-1"} style={{minWidth: "50px", maxWidth: "50px"}}>
                            <img src={GenerateImagePath.getPath(pr.Gtin, "")} alt=""
                                 style={{maxWidth: "50px", maxHeight: "50px"}}/>
                        </div>
                        <div className={"col-11 productName"} style={{padding: "0 30px"}}>{pr.Bezeichnung}</div>
                    </div>
                </div>
                <div className="text-right col-6">{pr.count}</div>
            </div>);
        });
        if (!g.products.length) { list.push(<div className={"row"}>{t('app.table.noProducts')}</div>);}
        return list;
    }
    function GetRLR(g, r) {
        return <div className={"room-container"} key={g.name + ' - ' + r.name}>
            <div className={"groupHeader"} dangerouslySetInnerHTML={{ __html: g.name + ' - ' + r.name }}></div>
            {project.isMyJung ? <div className={"tableHeader row " + language}>
                <div className="col-6">
                    <div className={"row"}>
                        <div className={"col-1"} style={{maxWidth: "50px"}}></div>
                        <div className={"col-11"}>{t('app.table.productName')}</div>
                    </div>
                </div>
                <div className="col-2" style={{textAlign: "left"}}>{t('app.table.artNo')}</div>
                <div className="col-2">{t('app.table.count')}</div>
                <div className="col-2">{t(isMyJung ? 'app.table.rrp.myjung' : 'app.table.rrp')}</div>
            </div> : <div className={"tableHeader row " + language}>
                <div className="col-6">
                    <div className={"row"}>
                        <div className={"col-1"} style={{maxWidth: "50px"}}></div>
                        <div className={"col-11"}>{t('app.table.productName')}</div>
                    </div>
                </div>
                <div className="col-6" style={{textAlign: "right"}}>{t('app.table.count')}</div>
            </div>}
            <div className={"groupContent"}>{generatePListForRoom(r)}</div>
        </div>;
    }
    function GetRLRGroup(g) {
        const list = [];
        g.rooms.forEach(room => {
            if (room.products && room.products.length) {
                list.push(GetRLR(g, room));
            }
        });
        return list;
    }
    function GetRoomListRoom(props) {
        const list = [];
        const roomFilterList = props.value;
        roomFilterList.forEach( g => {
            list.push(<div className={"floor-container"} key={g.name}>
                {GetRLRGroup(g)}
            </div>);
        });
        if (!list.length) { list.push(<div className={"row"} style={{margin: "15px 0"}}>Keine Produkte</div>); }
        return list;
    }
    function generateRoomList() {
        const list = [];
        list.push(<GetRoomListRoom key={'the-room-list'} value={productListAndFilters.roomFilterList} />);
        return list;
    }
    function generateProduktListForGroup(group, isAllRooms = false, ismj = false){
        let rlist = [];
        const lst = isAllRooms || productListAndFilters.productList;
        lst.forEach(p => {
            if(p.name === group.name){
                p.products.forEach((pr, idx) => {
                    rlist.push(project.isMyJung ? <div className={p.name + " " + idx} key={pr.Artikelnummer}>
                        <div className={"row bb-2 wpadding phoneNoShow"} key={pr.Artikelnummer}>
                        <div className="col-6" key={pr.Artikelnummer}>
                            <div className={"row"} style={{maxHeight: "50px"}}>
                                <div className={"col-1"} style={{minWidth: "50px", maxWidth: "50px"}}>
                                    <img src={GenerateImagePath.getPath(pr.Gtin, "")} alt=""
                                         style={{maxWidth: "50px", maxHeight: "50px", textAlign: "left"}}/>
                                </div>
                                <div className={"col-11 productName"} style={{padding: "0 30px"}}>{pr.Bezeichnung}</div>
                            </div>
                        </div>
                        <div className={"col-2 text-left"}
                             style={{padding: "0 0px", textAlign: "left"}}>{pr.Artikelnummer}</div>
                        <div className="col-2 text-right" style={{textAlign: "right"}}>{pr.count}</div>
                        <div className="text-right col-2">{pr.Preis >= 0 ? <NumberFormat value={(pr.Preis / 100) * pr.count}
                                                                        displayType={'text'} suffix={" €"}
                                                                        thousandSeparator={"."}
                                                                        decimalScale={2}
                                                                        fixedDecimalScale={true}
                                                                        decimalSeparator={","}/> : "Ohne Angabe"}</div>
                    </div>
                        <div className={"row bb-2 wpadding phoneShow " + group.name} key={pr.Artikelnummer}>
                            <div className={"col-1"} style={{minWidth: "50px", maxWidth: "50px"}}>
                                <img src={GenerateImagePath.getPath(pr.Gtin, "")} alt="" style={{maxWidth: "50px", maxHeight: "50px", textAlign: "left"}}/>
                            </div>
                            <div className={"col-11 productName phone-rows"} style={{padding: "0 30px"}}>
                                <div>{pr.Bezeichnung}</div>
                                <div>Artikelnummer: {pr.Artikelnummer}</div>
                                <div>Anzahl: {pr.count}</div>
                                <div>{t(isMyJung ? 'app.table.rrp.myjung' : 'app.table.rrp')}: {pr.Preis >= 0 ? <NumberFormat value={(pr.Preis / 100) * pr.count}
                                                                            displayType={'text'} suffix={" €"}
                                                                            thousandSeparator={"."}
                                                                            decimalScale={2}
                                                                            fixedDecimalScale={true}
                                                                            decimalSeparator={","}/> : "Ohne Angabe"}</div>
                            </div>
                        </div>
                    </div> : <div className={p.name + " " + idx} key={pr.Artikelnummer}>
                        <div className={"row bb-2 wpadding phoneNoShow " + group.name} key={pr.Artikelnummer}>
                            <div className="col-6" key={pr.Artikelnummer}>
                                <div className={"row"} style={{maxHeight: "50px"}}>
                                    <div className={"col-1"} style={{minWidth: "50px", maxWidth: "50px"}}>
                                        <img src={GenerateImagePath.getPath(pr.Gtin, "")} alt=""
                                             style={{maxWidth: "50px", maxHeight: "50px", textAlign: "left"}}/>
                                    </div>
                                    <div className={"col-11 productName"} style={{padding: "0 30px"}}>{pr.Bezeichnung}</div>
                                </div>
                            </div>
                            <div className="col-6 text-right" style={{textAlign: "right"}}>{pr.count}</div>
                        </div>
                        <div className={"row bb-2 wpadding phoneShow " + group.name} key={pr.Artikelnummer}>
                            <div className="col-10" key={pr.Artikelnummer}>
                                <div className={"row"} style={{maxHeight: "50px"}}>
                                    <div className={"col-1"} style={{minWidth: "50px", maxWidth: "50px"}}>
                                        <img src={GenerateImagePath.getPath(pr.Gtin, "")} alt=""
                                             style={{maxWidth: "50px", maxHeight: "50px", textAlign: "left"}}/>
                                    </div>
                                    <div className={"col-11 productName"} style={{padding: "0 30px"}}>{pr.Bezeichnung}</div>
                                </div>
                            </div>
                            <div className="col-2 text-right" style={{textAlign: "right"}}>{pr.count}</div>
                        </div>
                    </div>);
                });
                if (!p.products.length) { rlist.push(<div className={"row"}>Keine Produkte</div>);}
            }
        })
        return rlist.length > 0 ? rlist : <div className={"row"}>Keine Produkte</div>
    }
    function generateProduktListForGroupOptional(group){
        const list = [];
        const lst = productListAndFilters.optionalProducts;
        lst.forEach(p => {
            if(p.name === group.name){
                p.products.forEach(pr => {
                    list.push(project.isMyJung ?
                    <div className={"row bb-2 wpadding"} key={pr.Artikelnummer}>
                        <div className="col-6" key={pr.Artikelnummer}>
                            <div className={"row"} style={{maxHeight: "50px"}}>
                                <div className={"col-1"} style={{minWidth: "50px", maxWidth: "50px"}}>
                                    <img src={GenerateImagePath.getPath(pr.Gtin, "")} alt=""
                                         style={{maxWidth: "50px", maxHeight: "50px", textAlign: "left"}}/>
                                </div>
                                <div className={"col-11 productName"} style={{padding: "0 30px"}}>{pr.Bezeichnung}</div>
                            </div>
                        </div>
                        <div className={"col-2 text-left"}
                             style={{padding: "0 0px", textAlign: "left"}}>{pr.Artikelnummer}</div>
                        <div className="col-2 text-right" style={{textAlign: "right"}}>{pr.count}</div>
                        <div className="text-right col-2">{pr.Preis >= 0 ? <NumberFormat value={(pr.Preis / 100) * pr.count}
                                                                        displayType={'text'} suffix={" €"}
                                                                        thousandSeparator={"."}
                                                                        decimalScale={2}
                                                                        fixedDecimalScale={true}
                                                                        decimalSeparator={","}/> : "Ohne Angabe"}</div>
                    </div>
                    :
                    <div className={"row bb-2 wpadding"} key={pr.Artikelnummer}>
                        <div className="col-6" key={pr.Artikelnummer}>
                            <div className={"row"} style={{maxHeight: "50px"}}>
                                <div className={"col-1"} style={{minWidth: "50px", maxWidth: "50px"}}>
                                    <img src={GenerateImagePath.getPath(pr.Gtin, "")} alt=""
                                         style={{maxWidth: "50px", maxHeight: "50px", textAlign: "left"}}/>
                                </div>
                                <div className={"col-11 productName"} style={{padding: "0 30px"}}>{pr.Bezeichnung}</div>
                            </div>
                        </div>
                        <div className="col-6 text-right" style={{textAlign: "right"}}>{pr.count}</div>
                    </div>
                    );
                });
                if (!p.products.length) { list.push(<div className={"row"}>Keine Produkte</div>);}
            }
        })
        return list.length > 0 ? list : <div className={"row"}>Keine Produkte</div>
    }
    //TODO: remove fixed values
    let gesamtsumme = 5247.74;
    let mwst = 837.88; // gesamtsumme * 0.19;
    let beg = 1311.94; // gesamtsumme * 0.2;
    let gesamtsummeohnebeg = 6559.68; // gesamtsumme  + mwst;
    let nettopreis = 0;
    totals = {nettopreis: nettopreis, gesamtsummeohnebeg: gesamtsummeohnebeg, mwst: mwst, beg: beg, gesamtsumme: gesamtsumme};
    if (calculatedValues) {
        nettopreis = calculatedValues[0];
        gesamtsummeohnebeg = calculatedValues[4];
        mwst = calculatedValues[1]
        beg = calculatedValues[2];
        gesamtsumme = calculatedValues[3];
        totals = {nettopreis: nettopreis, gesamtsummeohnebeg: gesamtsummeohnebeg, mwst: mwst, beg: beg, gesamtsumme: gesamtsumme};
        showProjectPrices(totals);
    }
    if (productListAndFilters.isAllProducts) {
        productListAndFiltersAll = {...productListAndFiltersAll, totals: totals};
    }
    else {
        productListAndFiltersAll = {...productListAndFiltersAll, totals: {
                nettopreis: productListAndFiltersAll.calculatedValues[0],
                gesamtsummeohnebeg: productListAndFiltersAll.calculatedValues[4],
                mwst: productListAndFiltersAll.calculatedValues[1],
                beg: productListAndFiltersAll.calculatedValues[2],
                gesamtsumme: productListAndFiltersAll.calculatedValues[3]
        }};
    }
    const usedProducts = [];
    productListAndFilters.productList.forEach(group => {
        group.products.forEach(product => {
            usedProducts.push({itemNumber: product.Artikelnummer, itemName: product.Bezeichnung, itemCount: product.count, uvp: product.Preis});
        });
    });
    const finalStepData = trackingObj ? getFinalStepTracking() : null;
    if (project?.loadedFromCode && project.loadedFromCode !== null && project.loadedFromCode !== undefined && trackingObj) {
        let projectType = 'knx';
        if (isKonventionell) { projectType = 'konventionell'; }
        if (isHome) { projectType = 'home'; }
        const loadedApartmentType = initialProjectData[project.selectedMusterIx].name;
        calculatedValues = calculatePrices(products);
        nettopreis = calculatedValues[0];
        gesamtsummeohnebeg = calculatedValues[4];
        mwst = calculatedValues[1]
        beg = calculatedValues[2];
        gesamtsumme = calculatedValues[3];
        totals = {nettopreis: nettopreis, gesamtsummeohnebeg: gesamtsummeohnebeg, mwst: mwst, beg: beg, gesamtsumme: gesamtsumme};
        ProjectSaveService.saveTracking({
            trackingId: trackingObj.trackingId,
            finalStep: finalStepData,
            // saved: finalStepData,
            loadedAmount: parseFloat(totals.gesamtsummeohnebeg.replace('.','').replace(',','.')) * 100,
            step: 5,
            apartmentType: loadedApartmentType,
            projectType,
            b2b: project.isMyJung,
        }, undefined,isOldUrl,language, trackingObj);
    } else if (trackingObj) {
        ProjectSaveService.saveTracking({
            trackingId: trackingObj.trackingId,
            finalStep: Object.assign(finalStepData, {
                amount: parseFloat(totals.gesamtsummeohnebeg.replace('.','').replace(',','.')) * 100,
                usedProducts: usedProducts
            }),
            loadedAmount: null
        }, undefined,isOldUrl,language, trackingObj);
    }
    // console.log('totals', totals, lastSum, planungsCode, pCode, prCode, wasFiltered)
    if (lastSum === null) {
        setLastSum(totals.gesamtsummeohnebeg);
    } else if (totals.gesamtsummeohnebeg !== lastSum) {
        if (!wasFiltered) { setPrCode(null); }
        else { setWasFiltered(false); }
        setLastSum(totals.gesamtsummeohnebeg);
    } else if (project.loadedFromCode && !prCode && project.loadedCode ) {
        pCode = project.loadedCode;
        setPrCode(project.loadedCode);
    }
    function getFinalStepTracking() {
        let data = Object.assign(trackingObj.finalStep || {}, {
            amount: parseFloat(totals.gesamtsummeohnebeg.replace('.','').replace(',','.')) * 100,
            usedProducts: usedProducts,
            constructionProjectType : project.subProjectType || "neubau"
        });
        // step1 data
        if (project.selectedMusterIx !== undefined && project.selectedMusterIx !== null) {
            data = Object.assign(data, {apartmentType: initialProjectData[project.selectedMusterIx].name});
        }
        // step2 Data
        const levelName = project.selectedLevel > 2 ? 'Premium' : (project.selectedLevel > 1 ? 'Komfort' : 'Basic');
        data = Object.assign(data,{scopeOfEquipment: levelName});
        let selectedEquipments = [];
        project.floors.forEach(floor => {
            floor.rooms.forEach(room => {
                equipmentData2.forEach(ed => {
                    ed.options.forEach(opt => {
                        const found = selectedEquipments.filter(i => i.name === opt.name)[0];
                        let eq;
                        if (found) {
                            eq = Object.assign(found, {count: found.count + parseInt(room.selectedEquipment[opt.id] || 0,10)});
                        } else if (room.selectedEquipment[opt.id]) {
                            eq = {name: opt.name, count: parseInt(room.selectedEquipment[opt.id],10)};
                        }
                        if (eq) { selectedEquipments = [...selectedEquipments.filter(i => i.name !== opt.name), eq]; }
                    });
                });
            });
        });
        data = Object.assign(data || {}, {selectedEquipments: selectedEquipments});
        // step3 data
        let deviceSeries = [];
        project.floors.forEach(fl => {
            fl.rooms.forEach(room => {
                const serie = {
                    name: room.selectedDesign.selectedSerie.name || '',
                    operatingConcept: room.selectedDesign.selectedOperationConcept?.name || '',
                    color: room.selectedDesign.selectedColor1.colorName || ''
                };
                const found = deviceSeries.filter(i => i.name === serie.name && i.operatingConcept === serie.operatingConcept && i.color === serie.color)[0];
                // if (found) {
                //     deviceSeries = [...deviceSeries.filter(i => i.name !== serie.name || i.operatingConcept !== serie.operatingConcept || i.color !== serie.color), {...found, count: found.count + 1}];
                // } else {
                //     deviceSeries = [...deviceSeries, {...serie, count: 1}];
                // }
                deviceSeries = found ? [...deviceSeries] : [...deviceSeries, {...serie, count: 1}];
            });
        });
        data = Object.assign(data, {deviceSeries: deviceSeries});
        // step4 Data
        let selectedOptions = [];
        equipmentData4.forEach(ed => {
            if (ed.selectableFor === 'project') {
                ed.options.forEach(opt => {
                    const found = selectedOptions.filter(i => i.name === opt.id)[0];
                    let eq;
                    if (found) {
                        eq = Object.assign(found, {count: found.count + parseInt(project.selectedEquipment[opt.id] || 0,10)});
                    } else if (project.selectedEquipment[opt.id]) {
                        eq = {name: opt.id, count: parseInt(project.selectedEquipment[opt.id],10)};
                    }
                    if (eq) { selectedOptions = [...selectedOptions.filter(i => i.name !== opt.id), eq]; }
                });
            } else {
                project.floors.forEach(floor => {
                    floor.rooms.forEach(room => {
                        ed.options.forEach(opt => {
                            const found = selectedOptions.filter(i => i.name === opt.id)[0];
                            let eq;
                            if (found) {
                                eq = Object.assign(found, {count: found.count + parseInt(room.selectedEquipment[opt.id] || 0,10)});
                            } else if (room.selectedEquipment[opt.id]) {
                                eq = {name: opt.id, count: parseInt(room.selectedEquipment[opt.id],10)};
                            }
                            if (eq) { selectedOptions = [...selectedOptions.filter(i => i.name !== opt.id), eq]; }
                        });
                    });
                });
            }
        });
        data = Object.assign(data || {}, {selectedOptions: selectedOptions});

        return data;
    }
    function round(number){
        let num = Number((Math.abs(number) * 100).toPrecision(15));
        let finalNumber = Math.round(num) / 100 * Math.sign(number);
        finalNumber = finalNumber.toFixed(2);
        finalNumber = finalNumber.replace("." , ",");
        finalNumber = finalNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return finalNumber;
    }
    const HtmlTooltip2 = withStyles((theme) => ({
        tooltip: {
            backgroundColor: "var(--weiss)",
            color: "var(--color2)",
            fontSize: "14px",
            border: '1px solid transparent',
            maxWidth: '400px',
            minWidth: '130px',
            padding: "0px 7px",
            textAlign: "center",
            boxShadow: '0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)',
        },
    }))(Tooltip);
    function copyInClipboard(c) {
        var textField = document.createElement('textarea')
        textField.style.position = 'absolute';
        textField.style.left = '-100000px';
        textField.innerText = c;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        textField.remove();
        setInClipboard(true);
    }
    function InClipboardNotice() {
        setTimeout(() => { setInClipboard(false); }, 1000);
        return <div className={"inClipboardNotice"}>{t('app.notice.copied.code')}</div>;
    }
    function CopyIconSVG() {
        return <HtmlTooltip2 enterTouchDelay={50} title={<><p className={"copy-link-tooltip"}>{t('app.button.copy.code')}</p></>}>
            <svg viewBox="0 0 294 275.33" width="24" height="24" fill="var(--blueColor)" onClick={e => copyInClipboard(prCode ? prCode : (planungsCode ? planungsCode : pCode))}
                 style={{marginLeft: "5px", position: "relative", top: "3px", cursor: "pointer"}}
            >
                <path className="b"
                      d="M257.11,89.81h-123.87c-20.35,0-36.89,15.71-36.89,35.03v115.47c0,19.31,16.54,35.03,36.89,35.03h123.87c20.35,0,36.89-15.71,36.89-35.03V124.84c0-19.32-16.54-35.03-36.89-35.03Zm18.16,150.49c0,8.99-8.15,16.3-18.16,16.3h-123.87c-10.02,0-18.16-7.31-18.16-16.3V124.84c0-8.99,8.15-16.3,18.16-16.3h123.87c10.02,0,18.16,7.31,18.16,16.3v115.47Z"/>
                <path className="b"
                      d="M50.65,166.79h-13.76c-10.02,0-18.16-7.32-18.16-16.31V35.03c0-8.99,8.15-16.3,18.16-16.3h123.87c10.02,0,18.16,7.31,18.16,16.3v12.83c0,5.17,4.19,9.36,9.36,9.36s9.36-4.19,9.36-9.36v-12.83C197.65,15.71,181.11,0,160.76,0H36.89C16.54,0,0,15.71,0,35.03v115.47c0,19.31,16.54,35.03,36.89,35.03h13.76c5.17,0,9.36-4.19,9.36-9.36s-4.19-9.36-9.36-9.36Z"/>
            </svg>
        </HtmlTooltip2>;
    }
    const openInNewTab = (url) => {
        ProjectSaveService.saveTracking({
            trackingId: trackingObj.trackingId,
            merchant: 1
        }, null,isOldUrl,language, trackingObj);
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
        if (newWindow) { newWindow.opener = null; }
    };
    // const openUrl = (url) => {
    //     return () => openInNewTab(url)
    // };
    function keineUmlaute(text){
        text = text.replace(/ä/gi, "ae");
        text = text.replace(/ö/gi, "oe");
        text = text.replace(/ü/gi, "ue");
        text = text.replace(/ß/gi, "ss");
        return text;
    }
    function checkCode() {
        if (planungsCode || pCode) {
            downloadPdf();
            clearInterval(pCodeInterval);
        }
    }
    function checkCodeElbridge() {
        if (planungsCode || pCode) {
            sendElbridge();
            clearInterval(pCodeIntervalElbridge);
        }
    }
    function setPC(c) {
        getSha1(c).then();
        setPlanungsCode(c);
        setPrCode(c);
        setLastSum(totals.gesamtsummeohnebeg);
        // console.log('lastsum set to', totals.gesamtsumme, totals)
        pCode = c;
        if (callFunction === 'downloadCSV') { downloadCSV(); callFunction = ''; }
        if (callFunction === 'downloadFunctions') { downloadFunctions(); callFunction = ''; }
        if (callFunction === 'submitForm') { submitForm(); callFunction = ''; }
        if (callFunction === 'onSubmitHandler2') { onSubmitHandler2(); callFunction = ''; }
        if (callFunction === 'submitBoerseForm') { document.getElementById('boerseForm').requestSubmit(); callFunction = ''; }
        if (callFunction === 'handleSendProjektmanagerOpen') { handleSendProjektmanagerOpen(); callFunction = ''; }
    }
    function saveProject(showLightbox = false){
        // console.log('saveproject projectpro', projectPro, 'project', project);
        const pTypes = {'knx': 'KNX', 'home': 'Home', 'konventionell': 'Switch'};
        let structure = currentProject.combinations.items;
        const dataPM = {
            name: project.projectName !== '' ? project.projectName : project.name,
            projectType: pTypes[project.projectType],
            projectNr: "",
            contact: {salutation: "", firstname: "", lastname: "", company: "", street: "", street_nr: "", plz: "", city: ""},
            structure: structure,
            market: i18n.resolvedLanguage.toUpperCase()
        };
        ProjectSaveService.saveTracking({
            trackingId: trackingObj ? trackingObj.trackingId : '',
            saved: trackingObj ? trackingObj.finalStep : {}
        }, undefined,isOldUrl,language, trackingObj);
        // const projectPro = {
        //     name: currentProject.projectName && currentProject.projectName !== '' ? currentProject.projectName : currentProject.name,
        //     type: currentProject.projectType.toUpperCase(),
        //     buildings: currentProject.floors
        // };
        let projectPro = currentProject.projectPro || currentProject.generatedProject;
        projectPro = {...projectPro, name: project.projectName && project.projectName !== '' ? project.projectName : project.name};
        // console.log('projectpro', projectPro, 'project', project);
        // ProjectSaveService.saveProject(project, currentProject.projectPro || currentProject.generatedProject, currentProject, setPC, isOldUrl, i18n.resolvedLanguage);
        ProjectSaveService.saveProject(project, projectPro, dataPM, currentProject, setPC, isOldUrl, i18n.resolvedLanguage);
        // ProjectSaveService.saveProject(project, projectPro, currentProject, setPC, isOldUrl, i18n.resolvedLanguage);
        // if (showLightbox) { setUserInfoOpen(true); }
    }
    function downloadPdf(){
        setLoadingRoomBook(true);
        if (prCode && !pCode) { pCode = prCode; }
        if (!planungsCode && !pCode) {
            pCodeInterval = setInterval(checkCode, 500);
            saveProject();
            return;
        }
        let filterData = productListAndFiltersAll ? productListAndFiltersAll : {...productListAndFilters, calculatedValues: calculatedValues};
        let projectRooms = [];

        if(project.floors !== undefined){
            project.floors.forEach( g => {
                if(g.rooms !== undefined) {
                    projectRooms.push(g);
                }
            })
        }
        let categories = [];
        if (filterData.isAllRooms) {
            filterData.roomFilterList.forEach(g => {
                g.rooms.forEach(r => {
                    if (r.products && r.products.length) {
                        const catName = g.name + " - " + r.name;
                        categories.push({
                            name: catName.length ? catName : "Bedienstellen",
                            products: r.products.map(p => { return {...p, kategorie: catName.length ? catName : "Bedienstellen"}; })
                        });
                    }
                });
            });
        } else {
            const clst = []; let bst = {name: "Bedienstellen", products: []};
            filterData.productList.map(c => {
                if (c.name.length) {
                    if (c.name !== "Bedienstellen") { clst.push(c); }
                    else { bst = {...bst, products: [...bst.products, ...c.products]}; }
                }
                else { bst = {...bst, products: [...bst.products, ...c.products.map(p => {return {...p, kategorie: "Bedienstellen"};})]}; }
            });
            categories = [bst, ...clst];
        }
        const translations = {
            pname: t('app.pdf.projectname'),
            pcode: t('app.pdf.plancode'),
            date:  t('app.pdf.date'),
            page: t('app.pdf.page'),
            pnote: t('app.pdf.pnote'),
            serieTitel:  t('app.pdf.serieTitel'),
            serieP1:  t('app.pdf.serieP1'),
            serieP2:  t('app.pdf.serieP2'),
            colImage:  t('app.pdf.colImage'),
            colColor:  t('app.pdf.colColor'),
            colMaterial:  t('app.pdf.colMaterial'),
            colFloor:  t('app.pdf.colFloor'),
            colRoom:  t('app.pdf.colRoom'),
            productListTitle: t('app.pdf.productListTitle'),
            categories: {
                Bedienstellen: t('app.category.Bedienstellen'),
                Tastsensoren: t('app.category.Tastsensoren'),
                Tastsensor: t('app.category.Tastsensor'),
                Heizung: t('app.category.Heizung'),
                Heizungsventile: t('app.category.Heizungsventile'),
                Steckdose: t('app.category.Steckdose'),
                Steckdosen: t('app.category.Steckdosen'),
                Mediendosen: t('app.category.Mediendosen'),
                Rahmen: t('app.category.Rahmen'),
                Türkommunikation: t('app.category.Türkommunikation'),
                Radio: t('app.category.Radio'),
                Aktor: t('app.category.Aktor'),
                Aktoren: t('app.category.Aktoren'),
                Systemgeräte: t('app.category.Systemgeräte'),
                Sensoren: t('app.category.Sensoren'),
                Server: t('app.category.Server'),
                Bewegungsmelder: t('app.category.Bewegungsmelder'),
                Gateway: t('app.category.Gateway'),
                Temperaturregler: t('app.category.Gateway')
            },
            colItemName: t('app.pdf.colItemName'),
            colCount: t('app.pdf.colCount'),
            colArtNr: t('app.pdf.colArtNr'),
            colUVP: t('app.pdf.colUVP'),
            colSum: t('app.pdf.colSum'),
            colCosts: t('app.pdf.colCosts'),
            colMWST: t('app.pdf.colMWST'),
            colFoerderung: t('app.pdf.colFoerderung'),
            colCostsAndF: t('app.pdf.colCostsAndF'),
            textInfo: t('app.pdf.textInfo'),
            textEndNote: t('app.pdf.textEndNote'),
            textP1: t('app.pdf.textP1'),
            textP2: t('app.pdf.textP2'),
            coverText: t('app.pdf.coverText')
        };
        const products = JSON.stringify(
            {
                name: (project.projectName || project.name).replace('<sup>2</sup>','²'),
                projectType: project.projectType,
                productCategories: categories,
                foerderung_1: foerderung1,
                foerderung_2: foerderung2,
                foerderung_3: foerderung3,
                calculatedValues: [
                    filterData.calculatedValues[4], filterData.calculatedValues[1], filterData.calculatedValues[2], filterData.calculatedValues[3], filterData.calculatedValues[1]
                ],
                projectRooms,
                planungscode: planungsCode || pCode,
                pdfLogo: '<?xml version="1.0" encoding="UTF-8" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg height="100%" stroke-miterlimit="10" style="fill-rule:nonzero;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;" version="1.1" viewBox="0 0 78 20" width="100%" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs/><g id="Untitled"><path d="M34.8 12.2C34.8 12.9 34.4 15.7 29.8 15.7C25.1 15.7 24.8 12.8 24.8 12.2L24.8 3.2L21.7 3.2L21.7 15.6C21.7 15.9 21.7 16.2 22.2 16.8C22.7 17.3 23.4 17.2 23.4 17.2L36.1 17.2C36.1 17.2 36.8 17.2 37.3 16.7C37.8 16.2 37.8 15.4 37.8 15.4L37.8 3.2L34.7 3.2L34.8 12.2M33 1.4L44.1 1.4L52.2 11.2L52.2 1.4L75.2 1.4L75.2 6.8L63.8 6.8L63.8 12.3C63.8 13.4 64.7 13.9 66.7 13.9C69.3 13.9 69.7 12.9 69.7 12.3L69.7 11.1L67.2 11.1L67.2 9.3L75.1 9.3L75.1 15.6C75.1 16.5 74.8 17.3 74.1 18.1C73.2 19 72.3 19.1 71.6 19.1L60.5 19.1C59.8 19.1 58.9 19 58 18.1L58 17.9L58 19L51.4 19L44.7 11.3L44.7 19L38.9 19L38.9 17.9C38.9 17.9 38.9 18 38.8 18C37.9 18.9 37 19 36.3 19L23.4 19C22.7 19 21.8 18.9 20.9 18L20.8 17.9L20.7 18C19.8 18.9 18.9 19 18.2 19L7.1 19C6.4 19 5.5 18.9 4.6 18C3.9 17.3 3.6 16.4 3.6 15.5L3.6 9.3L9 9.3L9 12.3C9 12.9 9.3 13.9 12 13.9C14 13.9 14.9 13.3 14.9 12.3L14.9 6.8L3.6 6.8L3.6 1.4L26.6 1.4L26.6 12.3C26.6 12.9 27.1 13.9 29.8 13.9C32.5 13.9 33 12.9 33 12.3L33 1.4L33 1.4ZM39.7 3.2L39.7 17.2L42.8 17.2L42.8 8.2L44.3 8.2L52.2 17.2L57 17.2L57 3.2L54 3.2L54 14.3L52.4 14.3L43.2 3.2L39.7 3.2ZM73.3 3.2L73.3 5L61.9 5L61.9 12.3C61.9 13 62.1 15.8 66.6 15.8C71.3 15.8 71.5 12.9 71.5 12.3L71.5 11.1L73.3 11.1L73.3 15.4C73.3 15.8 73.3 16.3 73 16.6C72.6 17 72.2 17.2 71.7 17.2L60.5 17.2C60.5 17.2 59.7 17.2 59.2 16.5C58.8 16 58.9 15.4 58.9 15.4L58.9 3.2L73.3 3.2L73.3 3.2ZM5.4 3.2L5.4 5L16.8 5L16.8 12.3C16.8 13 16.6 15.8 12.1 15.8C7.4 15.8 7.2 12.9 7.2 12.3L7.2 11.1L5.4 11.1L5.4 15.4C5.4 15.8 5.4 16.3 5.7 16.6C6.1 17 6.5 17.2 7 17.2L18.2 17.2C18.2 17.2 19 17.2 19.5 16.5C19.9 16 19.8 15.4 19.8 15.4L19.8 3.2L5.4 3.2L5.4 3.2Z" fill="#000000" fill-rule="evenodd" opacity="1" stroke="none"/></g></svg>',
                fontColor: [[45, 97, 136], [45, 97, 136], [45, 97, 136]],
                font: 'Filson W04 Regular',
                coverPicture: '',
                imgPrefix: "https://www.projekt14.de/austausch/quick_j/JUNG_",
                hersteller: 'jung',
                blueColor: [45, 97, 136],
                welcome: {
                    title1: t('app.pdf.title1'),
                    text1: t('app.pdf.text1'),
                    image: 'welcome_bild.jpg',
                    title2: t('app.pdf.title2'),
                    text2: t('app.pdf.text2')
                },
                translations: translations,
                isMyJung: project.isMyJung,
                language: language
            },
            ["picture", "image", "text2", "text1", "title2", "title1", "welcome", "blueColor", "hersteller", "imgPrefix", "coverPicture", "font", "fontColor", "pdfLogo", "productCategories", "name", "id", "projectType", "products", "rooms","Artikelnummer", "Bezeichnung", "Gtin" , "Preis" , "UID-Pro", "count", "kategorie", "foerderung_1" , "foerderung_2" , "foerderung_3", "calculatedValues", "projectRooms", "selectedDesign", "selectedColor1", "selectedColor2",
                "colorId", "colorName", "finishName", "materialName", "selectedSerie", "planungscode", "isMyJung", "translations",
                "pname", "pcode", "date", "serieTitel", "serieP1", "serieP2", "colImage", "colColor", "colMaterial", "colFloor", "colRoom",
                "productListTitle", "categories", "Bedienstellen", "Tastsensoren", "Tastsensor", "Heizung", "Heizungsventile", "Steckdose",
                "Steckdosen", "Mediendosen", "Rahmen", "Türkommunikation", "Radio", "Aktor", "Aktoren", "Systemgeräte", "Sensoren", "Server","Temperaturregler",
                "colItemName", "colCount", "colUVP", "colArtNr", "colSum", "colCosts", "colMWST", "colFoerderung", "colCostsAndF",
                "textInfo", "textEndNote", "textP1", "textP2", "page", "pnote", "language", "coverText","Bewegungsmelder","Gateway"
            ]);
        const regex = /<sup>/g;
        const regex2 = /<\/sup>/g;

        fetch(
            process.env.REACT_APP_QUICK_BACKEND_URL + "/download/pflichtenheft_quick",
            {
                method: "post",
                body: products.replaceAll(regex,'').replaceAll(regex2, '')
            }
        ).then( (res)  => {
                res.blob().then((blob) => {
                    // const filename = dispo.slice(("attachment; filename=\"").length, dispo.length - 1);
                    const d = new Date();
                    d.toLocaleString();
                    let year = d.getFullYear();
                    let month = d.getMonth();
                    let day = d.getDate();

                    month += 1;

                    let filename = "JUNG";
                    if (project.projectType === "knx") { filename += '-KNX_'; }
                    if (project.projectType === "konventionell") { filename += '_'; }
                    if (project.projectType === "home") { filename += '-HOME_'; }
                    let projectname = project.projectName || project.name;
                    projectname = projectname.split(' ').join('_');
                    projectname = projectname.replaceAll(regex,'').replaceAll(regex2, '');
                    projectname = projectname.length > 30 ? projectname.slice(0, 30) : projectname;
                    filename += t('app.button.roomBook') + "_" + projectname + "_" + year + "-" + (month < 10 ? "0" : "") + month + "-" + (day < 10 ? "0" : "") + day;
                    filename+= ".pdf";

                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        "download",
                        filename,
                    );
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    setLoadingRoomBook(false);
                })
            }
        )
        ProjectSaveService.saveTracking({trackingId: trackingObj.trackingId, downloadedRoomBook: 1}, undefined,isOldUrl,language, trackingObj);
    }
    function downloadFunctions(){
        setLoadingFunctions(true);
        if (prCode && !pCode) { pCode = prCode; }
        if (!planungsCode && !pCode) {
            callFunction = 'downloadFunctions';
            saveProject();
            return;
        }
        let coverUrl = "https://projekt14.de/austausch/quick_j/pdf_cover/home-2.jpg";
        if (['nl','es'].includes(language)) { coverUrl = "https://projekt14.de/austausch/quick_j/pdf_cover/home_nl.png"; }
        const products = JSON.stringify(
            {
                hersteller: 'jung',
                mergePdf: true,
                language: language,
                pdfFiles: currentProject.functionsList,
                planungscode: planungsCode || pCode,
                additionalPages: [
                    {
                        "content": [
                            {
                                "type": "title",
                                "value": t('app.pdf.title1'),
                            },
                            {
                                "type": "text",
                                "value": t('app.pdf.text1'),
                            },
                            {
                                "type": "image",
                                "value": "welcome_bild.jpg"
                            },
                            {
                                "type": "title",
                                "value": t('app.pdf.title2'),
                            },
                            {
                                "type": "text",
                                "value": t('app.pdf.text2')
                            }
                        ]
                    },
                    {
                        "content": [
                            {
                                "type": "title",
                                "value": t('app.pdf.title3')
                            },
                            {
                                "type": "image",
                                "value": "home-3.png"
                            },
                            {
                                "type": "text",
                                "value": t('app.pdf.text3')
                            },
                            {
                                "type": "text",
                                "value": t('app.pdf.text4')
                            },
                            {
                                "type": "text",
                                "value": t('app.pdf.text5')
                            }
                        ]
                    },
                    {
                        "bgImage": "home-4.png",
                        "content": [
                            {
                                "type": "title",
                                "value": t('app.pdf.title4')
                            }
                        ]
                    }
                ],
                blueColor: [45, 97, 136],
                pdfLogo: '<?xml version="1.0" encoding="UTF-8" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg height="100%" stroke-miterlimit="10" style="fill-rule:nonzero;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;" version="1.1" viewBox="0 0 78 20" width="100%" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs/><g id="Untitled"><path d="M34.8 12.2C34.8 12.9 34.4 15.7 29.8 15.7C25.1 15.7 24.8 12.8 24.8 12.2L24.8 3.2L21.7 3.2L21.7 15.6C21.7 15.9 21.7 16.2 22.2 16.8C22.7 17.3 23.4 17.2 23.4 17.2L36.1 17.2C36.1 17.2 36.8 17.2 37.3 16.7C37.8 16.2 37.8 15.4 37.8 15.4L37.8 3.2L34.7 3.2L34.8 12.2M33 1.4L44.1 1.4L52.2 11.2L52.2 1.4L75.2 1.4L75.2 6.8L63.8 6.8L63.8 12.3C63.8 13.4 64.7 13.9 66.7 13.9C69.3 13.9 69.7 12.9 69.7 12.3L69.7 11.1L67.2 11.1L67.2 9.3L75.1 9.3L75.1 15.6C75.1 16.5 74.8 17.3 74.1 18.1C73.2 19 72.3 19.1 71.6 19.1L60.5 19.1C59.8 19.1 58.9 19 58 18.1L58 17.9L58 19L51.4 19L44.7 11.3L44.7 19L38.9 19L38.9 17.9C38.9 17.9 38.9 18 38.8 18C37.9 18.9 37 19 36.3 19L23.4 19C22.7 19 21.8 18.9 20.9 18L20.8 17.9L20.7 18C19.8 18.9 18.9 19 18.2 19L7.1 19C6.4 19 5.5 18.9 4.6 18C3.9 17.3 3.6 16.4 3.6 15.5L3.6 9.3L9 9.3L9 12.3C9 12.9 9.3 13.9 12 13.9C14 13.9 14.9 13.3 14.9 12.3L14.9 6.8L3.6 6.8L3.6 1.4L26.6 1.4L26.6 12.3C26.6 12.9 27.1 13.9 29.8 13.9C32.5 13.9 33 12.9 33 12.3L33 1.4L33 1.4ZM39.7 3.2L39.7 17.2L42.8 17.2L42.8 8.2L44.3 8.2L52.2 17.2L57 17.2L57 3.2L54 3.2L54 14.3L52.4 14.3L43.2 3.2L39.7 3.2ZM73.3 3.2L73.3 5L61.9 5L61.9 12.3C61.9 13 62.1 15.8 66.6 15.8C71.3 15.8 71.5 12.9 71.5 12.3L71.5 11.1L73.3 11.1L73.3 15.4C73.3 15.8 73.3 16.3 73 16.6C72.6 17 72.2 17.2 71.7 17.2L60.5 17.2C60.5 17.2 59.7 17.2 59.2 16.5C58.8 16 58.9 15.4 58.9 15.4L58.9 3.2L73.3 3.2L73.3 3.2ZM5.4 3.2L5.4 5L16.8 5L16.8 12.3C16.8 13 16.6 15.8 12.1 15.8C7.4 15.8 7.2 12.9 7.2 12.3L7.2 11.1L5.4 11.1L5.4 15.4C5.4 15.8 5.4 16.3 5.7 16.6C6.1 17 6.5 17.2 7 17.2L18.2 17.2C18.2 17.2 19 17.2 19.5 16.5C19.9 16 19.8 15.4 19.8 15.4L19.8 3.2L5.4 3.2L5.4 3.2Z" fill="#000000" fill-rule="evenodd" opacity="1" stroke="none"/></g></svg>',
                fontColor: [[45, 97, 136], [45, 97, 136], [45, 97, 136]],
                font: 'Filson W04 Regular',
                coverPicture: '',
                imgPrefix: "https://www.projekt14.de/austausch/quick_j/JUNG_",
                name: (project.projectName || project.name).replace('<sup>2</sup>','²'),
                projectType: project.projectType,
                coverUrl: coverUrl,
                translations: {
                    "pcode": t('app.pdf.plancode'),
                    "pname": t('app.pdf.projectname'),
                    "coverTitle": t('app.pdf.functionsBook')
                }
            },
            ["hersteller", "mergePdf", "pdfFiles", "planungscode", "additionalPages", "bgImage", "content", "type", "value", "blueColor", "pdfLogo", "fontColor", "font", "coverPicture", "imgPrefix", "name", "projectType", "coverUrl", "language", "translations", "pcode", "pname", "coverTitle"]);

        fetch(
            process.env.REACT_APP_QUICK_BACKEND_URL + "/download/pflichtenheft_quick",
            {
                method: "post",
                body: products
            }
        ).then( (res)  => {
                res.blob().then((blob) => {
                    // const filename = dispo.slice(("attachment; filename=\"").length, dispo.length - 1);
                    const d = new Date();
                    d.toLocaleString();
                    let year = d.getFullYear();
                    let month = d.getMonth();
                    let day = d.getDate();

                    month += 1;

                    let filename = "JUNG";
                    if (project.projectType === "knx") { filename += '-KNX_'; }
                    if (project.projectType === "konventionell") { filename += '_'; }
                    if (project.projectType === "home") { filename += '-HOME_'; }
                    let projectname = project.projectName || project.name;
                    projectname = projectname.split(' ').join('_');
                    projectname = projectname.length > 30 ? projectname.slice(0, 30) : projectname;
                    filename += t('app.pdf.functions') + "_" + projectname + "_" + year + "-" + (month < 10 ? "0" : "") + month + "-" + (day < 10 ? "0" : "") + day;
                    filename+= ".pdf";

                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        "download",
                        filename,
                    );
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    setLoadingFunctions(false);
                })
            }
        )
        ProjectSaveService.saveTracking({trackingId: trackingObj.trackingId, downloadedSpecificationBook: 1}, undefined,isOldUrl,language, trackingObj);
    }
    function downloadCSV(){
        if (prCode && !pCode) { pCode = prCode; }
        if (!planungsCode && !pCode) {
            callFunction = 'downloadCSV';
            saveProject();
            return;
        }
        let filterData = productListAndFiltersAll ? productListAndFiltersAll : {...productListAndFilters, calculatedValues: calculatedValues, totals: totals};
        let jsonData = t('app.csv.lfdnr') + ";" + (filterData.isAllRooms ? (t('app.csv.room') + ';') : "") + t('app.table.artNo') + ";" + t('app.csv.description') + ";" + t('app.table.rrp') + ";" + t('app.table.count') + ";" + t('app.csv.sum') + ";\n";
        let lfdnr = 0;
        setLoadingCSV(true);
        filterData.productList.forEach( g => {
            g.products.forEach(p => {
                if (!p.isOptional) {
                    lfdnr += 1;
                    let gesamtpreis = round(p.Preis / 100 * p.count);
                    if (parseFloat(gesamtpreis.replace(',', '.')) < 0) { gesamtpreis = t('app.csv.unspecified'); }
                    let formatierterPreis = round(p.Preis / 100);
                    if (parseFloat(formatierterPreis.replace(',', '.')) < 0) { formatierterPreis = t('app.csv.unspecified'); }
                    let formatierteBezeichnung = keineUmlaute(p.Bezeichnung);
                    if (!filterData.isAllRooms) {
                        jsonData += lfdnr + ";" + p.Artikelnummer + ";" + formatierteBezeichnung + ";" + formatierterPreis + ";" + p.count + ";" + gesamtpreis + ";\n";
                    } else {
                        jsonData += lfdnr + ";" + (p.floorName + ' - ' + p.roomName) + ";" + p.Artikelnummer + ";" + formatierteBezeichnung + ";" + formatierterPreis + ";" + p.count + ";" + gesamtpreis + ";\n";
                    }
                }
            })
        })
        jsonData += "\n";
        let extraChar = filterData.isAllRooms ? ';' : '';
        if(currentProject.projectType === 'knx' || currentProject.projectType === 'easy' || currentProject.projectType === 'home' ){
            jsonData += ";;;;" + t('app.csv.sum.netto') + ";" + filterData.totals.nettopreis + "" + extraChar + "\n";
            jsonData += ";;;;" + t('app.csv.mwst') + ";" + filterData.totals.mwst + "" + extraChar + "\n";
            jsonData += ";;;;" + t('app.csv.grandTotal') + ";" + filterData.totals.gesamtsummeohnebeg + "" + extraChar + "\n";
            jsonData += ";;;;" + t('app.csv.beg') + ";" + filterData.totals.beg + "" + extraChar + "\n";
            jsonData += ";;;;" + t('app.csv.grandTotal') + ";" + filterData.totals.gesamtsumme + "" + extraChar + "\n";
        }else if (currentProject.projectType === 'konventionell'){
            jsonData += ";;;;" + t('app.csv.sum.netto') + ";" + filterData.totals.nettopreis + "" + extraChar + "\n";
            jsonData += ";;;;" + t('app.csv.mwst') + ";" + filterData.totals.mwst + "" + extraChar + "\n";
            jsonData += ";;;;" + t('app.csv.grandTotal') + ";" + filterData.totals.gesamtsummeohnebeg + "" + extraChar + "\n";
        }

        if (filterData.optionalProducts.length) {
            jsonData += "\n";
            jsonData += ";" + t('app.csv.optional') + ";;;;;\n";
            jsonData += t('app.csv.lfdnr') + ";" + (filterData.isAllRooms ? (t('app.csv.room') + ';') : "") + t('app.table.artNo') + ";" + t('app.csv.description') + ";" + t('app.table.rrp') + ";" + t('app.table.count') + ";" + t('app.csv.sum') + ";\n";
            let lfdnr2 = 0;
            let netto = 0; let mwst; let gesamtsummeohnebeg;
            filterData.optionalProducts.forEach( g => {
                g.products.forEach(p => {
                    lfdnr2 += 1;
                    netto += (p.Preis / 100) * p.count;
                    let gesamtpreis = round(p.Preis / 100 * p.count);
                    let formatierterPreis = round(p.Preis / 100);
                    let formatierteBezeichnung = keineUmlaute(p.Bezeichnung);
                    if (!filterData.isAllRooms) {
                        jsonData += lfdnr2 + ";" + p.Artikelnummer + ";" + formatierteBezeichnung + ";" + formatierterPreis + ";" + p.count + ";" + gesamtpreis + ";\n";
                    } else {
                        jsonData += lfdnr2 + ";" + (p.floorName + ' - ' + p.roomName) + ";" + p.Artikelnummer + ";" + formatierteBezeichnung + ";" + formatierterPreis + ";" + p.count + ";" + gesamtpreis + ";\n";
                    }
                })
            });
            mwst = netto * 0.19;
            gesamtsummeohnebeg = netto + mwst;
            jsonData += "\n";
            let extraChar = filterData.isAllRooms ? ';' : '';
            jsonData += ";;;;" + t('app.csv.sum.netto') + ";" + round(netto) + "" + extraChar + "\n";
            jsonData += ";;;;" + t('app.csv.mwst') + ";" + round(mwst) + "" + extraChar + "\n";
            jsonData += ";;;;" + t('app.csv.grandTotal') + ";" + round(gesamtsummeohnebeg) + "" + extraChar + "\n";
            jsonData += "\n";
        }
        // console.log('filterdata', filterData)
        jsonData += ";;" + t('app.csv.planning.code') + ": " + (planungsCode ? planungsCode : pCode) + ";;;" + extraChar + "\n";
        jsonData += ";;" + t('app.csv.room') + ": " + (filterData.room !== t('app.csv.all') ? filterData.room : t('app.csv.general.overview')) + ";;;" + extraChar + "\n";
        jsonData += ";;" + t('app.csv.product') + ": " + (filterData.product ? filterData.product : t('app.csv.product.all')) + ";;;" + extraChar + "\n";

        let csvFile = "data:text/csv;charset=utf-8,";

        csvFile = jsonData;

        const d = new Date();
        d.toLocaleString();
        let year = d.getFullYear();
        let month = d.getMonth();
        let day = d.getDate();

        month += 1;

        let filename = "JUNG";
        if (project.projectType === "knx") { filename += '-KNX_'; }
        if (project.projectType === "konventionell") { filename += '_'; }
        if (project.projectType === "home") { filename += '-HOME_'; }
        let projectname = project.projectName || project.name;
        projectname = projectname.split(' ').join('_');
        projectname = projectname.length > 30 ? projectname.slice(0, 30) : projectname;
        filename += t('app.csv.partslist') + "_" + projectname + "_" + year + "-" + (month < 10 ? "0" : "") + month + "-" + (day < 10 ? "0" : "") + day;
        filename += '.csv';

        let blob = new Blob(["\ufeff" + csvFile], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, filename);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setLoadingCSV(false);
            }
        }
        ProjectSaveService.saveTracking({trackingId: trackingObj.trackingId, downloadedCsv: 1}, undefined,isOldUrl,language, trackingObj);
    }
    function CSVFree() {
        return <>{t('app.button.partsList')}</>;
    }
    function CSVBusy() {
        return <div className="btn_loading"></div>;
    }
    function getCSVButtonLabel() {
        if (loadingCSV) { return <CSVBusy/>; }
        return <CSVFree/>;
    }
    function RoomBookFree() {
        return <>{t('app.button.roomBook')}</>;
    }
    function RoomBookBusy() {
        return <CSVBusy/>;
    }
    function getRoomBookButtonLabel() {
        if (loadingRoomBook) { return <RoomBookBusy/>; }
        return <RoomBookFree/>;
    }
    function getFunctionsButtonLabel() {
        if (loadingFunctions) { return <RoomBookBusy/>; }
        return <>{t('app.button.functionBook')}</>;
    }
    function selectFunctionFilterValue(id) {
        setSelectedFunctionCat(id);
    }
    function generateFunktionenFilter() {
        let mFiles = matrix_files;
        if (language === 'en') { mFiles = matrix_files_en; }
        if (language === 'es') { mFiles = matrix_files_es; }
        if (language === 'fr') { mFiles = matrix_files_fr; }
        if (language === 'it') { mFiles = matrix_files_it; }
        if (language === 'at') { mFiles = matrix_files_at; }
        if (language === 'nl') { mFiles = matrix_files_nl; }
        const list = [];
        list.push(<MenuItem value={"functionsFilter-all"} key={"functionsFilter-all"} style={{fontSize: "inherit"}} className={"functionsFilterItem"} onClick={e => selectFunctionFilterValue(undefined)}>{t('app.option.scope')}</MenuItem>);
        if (currentProject.functionsCats) {
            Object.keys(currentProject.functionsCats).forEach(key => {
                const f = currentProject.functionsCats[key];
                const cat = mFiles.filter(i => i.id === f.cat)[0];
                list.push(<MenuItem value={cat.id} key={cat.id} style={{fontSize: "inherit"}}
                                         className={"roomFilterFloorItem"}
                                         onClick={e => selectFunctionFilterValue(cat.id)}
                >{cat.cat}</MenuItem>);
            });
        }
        return list;
    }
    function GenerateFilteredFunctionen() {
        let mFiles = matrix_files;
        if (language === 'en') { mFiles = matrix_files_en; }
        if (language === 'es') { mFiles = matrix_files_es; }
        if (language === 'fr') { mFiles = matrix_files_fr; }
        if (language === 'it') { mFiles = matrix_files_it; }
        if (language === 'at') { mFiles = matrix_files_at; }
        if (language === 'nl') { mFiles = matrix_files_nl; }
        let html = [];
        Object.keys(currentProject.functionsCats).forEach(key => {
            const f = currentProject.functionsCats[key];
            if (f.cat === selectedFunctionCat || !selectedFunctionCat) {
                f.files.forEach(r => {
                    const file = mFiles.filter(i => i.id === r)[0];
                    if (file) {
                        html.push(<div className={"row"} style={{width: '100%', color: 'var(--textColor)', background: 'var(--weiss)', padding: '15px 0', marginBottom: '1px'}}>
                            <div className={"col-1 phoneNoShow"} style={{width: '200px', paddingLeft: '15px'}}><img src={funcImgUrl + file.image} style={{width: '100%'}} alt={""} /></div>
                            <div className={"col-2 phone-plr-10"} style={{paddingLeft: '15px'}}>{file.cat}</div>
                            <div className={"col-2 phoneNoShow"}>{file.title}</div>
                            <div className={"col-7"} style={{paddingRight: '15px'}}><p className={"phoneShow"} style={{marginTop: '0'}}>{file.title}</p> {file.text}</div>
                        </div>);
                    }
                });
            }
        });
        return html;
    }
    const CircleButton = withStyles((theme) => ({
        root: {
            cursor: "pointer",
            borderRadius: "22px",
            width: "22px",
            height: "22px",
            textAlign: "center",
            border: "none",
            minWidth: "unset",
            overflow: "hidden",
            padding: "0 0 0 4px",
            margin: "0 7px 0 2px"
        },
    }))(Button);
    function TooltipWithButton(props) {
        const el = document.createElement('a');
        document.body.appendChild(el);
        const [anchorEl, setAnchorEl] = React.useState(null);
        const [opened, setOpened] = React.useState(false);
        const id = 'popover_' + ((Math.random() * 1000) + 1);
        const open = Boolean(anchorEl);
        const params = props.props;
        const handleClick = (event) => { event.preventDefault(); event.stopPropagation(); setAnchorEl(event.currentTarget); setOpened(true); return false; };
        const handleClose = (event) => { event.preventDefault(); event.stopPropagation(); setAnchorEl(null); setOpened(false); return false; };
        return <>
            <Button aria-describedby={id} variant="contained" onClick={handleClick}
                    className={"button-without-style" + (!params.active ? (!params.noActive ? ' inactive' : '') : '') + (params.absolutePosition ? ' absolutePosition' : '')}
                    style={{right: params.marginLeft !== undefined ? 0 : 'unset'}}
            >
                {params.active
                    ? <span className="info-icon">
                        <img src={iIconActive} width="32" height="32" style={{marginTop: "-14px"}} alt={"info"} className={"paramActive"}/>
                    </span>
                    : (!params.noActive
                            ? <span className="info-icon">
                            <img src={iIconBlue} width="32" height="32" style={{marginTop: "-14px"}} alt={"info"} className={"hideOnHover"}/>
                            <img src={iIconActive} width="32" height="32" style={{marginTop: "-14px"}} alt={"info"} className={"showOnHover"}/>
                        </span>
                            : <span>
                            <img src={iIconBlue} width="32" height="32" style={{marginTop: "2px"}} alt={"info"} className={"paramNoActive"}/>
                        </span>
                    )
                }
            </Button>
            {'parentIFrame' in window
            ? <Popover id={id} open={true} anchorEl={anchorEl} onClose={handleClose}
                   anchorOrigin={{
                       vertical: 'bottom',
                       horizontal: 'left',
                   }}
                   style={{maxWidth: window.innerWidth > 800 ? '75%' : '100%', visibility: opened ? 'visible' : 'hidden'}}
            >
                <div className={"popoverContainer"} style={{color: 'var(--blueColor)', padding: '15px', position: 'relative'}}>
                    <a href={"/"} onClick={handleClose} style={{position: 'absolute', top: '5px', right: '5px', color: 'var(--blueColor)'}}><CloseIcon /></a>
                    <p style={{fontWeight: 'bold'}}>{params.title}</p>
                    <p dangerouslySetInnerHTML={{__html: params.message}}></p>
                </div>
            </Popover>
            : <Popover id={id} open={open} anchorEl={anchorEl} onClose={handleClose}
                     anchorOrigin={{
                         vertical: 'bottom',
                         horizontal: 'left',
                     }}
                     style={{maxWidth: window.innerWidth > 800 ? '75%' : '100%', visibility: opened ? 'visible' : 'hidden'}}
            >
                <div className={"popoverContainer"} style={{color: 'var(--blueColor)', padding: '15px', position: 'relative'}}>
                    <a href={"/"} onClick={handleClose} style={{position: 'absolute', top: '5px', right: '5px', color: 'var(--blueColor)'}}><CloseIcon /></a>
                    <p style={{fontWeight: 'bold'}}>{params.title}</p>
                    <p dangerouslySetInnerHTML={{__html: params.message}}></p>
                </div>
            </Popover>
            }
        </>;
    }
    function checker(opt) {
        if (opt === 1) { return <Checkbox checked={foerderung1} color="default" onChange={e => setFoerderung1(e.currentTarget.checked)} style={{padding: "0 5px 0 0"}} />;}
        if (opt === 2) { return <Checkbox checked={foerderung2} color="default" onChange={e => setFoerderung2(e.currentTarget.checked)} style={{padding: "0 5px 0 0"}} />; }
        if (opt === 3) { return <Checkbox className={"mobile-pr5"} checked={foerderung3} color="default" onChange={e => setFoerderung3(e.currentTarget.checked)} style={{padding: "0 0 0 0"}} />; }
    }
    function showProjectPrices(data) {
        gesamtsummeohnebeg = data.gesamtsummeohnebeg;
        beg = data.beg;
        gesamtsumme = data.gesamtsumme;
    }
    function PriceBox(props) {
        if (!props.opener && window.innerWidth > 800) {
            return <div className={"padding-container"} style={{paddingBottom: "15px", paddingTop: '15px'}}>
                <div className={"section-header"} style={{fontWeight: language === 'nl' ? 'bold' : 'normal'}}>
                    <div className={"section-title"} style={{
                        display: 'flex',
                        alignItems: 'center'
                    }}>{t('app.pricebox.costs')}
                        {language === 'de' ? <TooltipWithButton props={{noActive: true, title: '', message: t(isMyJung ? 'app.pricebox.costs.info.myjung' : 'app.pricebox.costs.info')}} /> : null}
                    </div>
                    <div className={"section-title"} style={{fontWeight: language === 'nl' ? 'bold' : 'normal'}}>
                        {project.projectType === 'konventionell'
                            ? <strong><NumberFormat value={isMyJung ? parseFloat(gesamtsummeohnebeg.replace('.','').replace(',','.')) / (currentPercent + 1) : gesamtsummeohnebeg}
                                                                displayType={'text'} suffix={" €*"}
                                                                thousandSeparator={"."}
                                                                decimalScale={2}
                                                                fixedDecimalScale={true}
                                                                decimalSeparator={","}/>&nbsp;&nbsp;</strong>
                            : <span><NumberFormat value={isMyJung ? parseFloat(gesamtsummeohnebeg.replace('.','').replace(',','.')) / (currentPercent + 1) : gesamtsummeohnebeg}
                                                  displayType={'text'} suffix={" €*"}
                                                  thousandSeparator={"."}
                                                  decimalScale={2}
                                                  fixedDecimalScale={true}
                                                  decimalSeparator={","}/>&nbsp;&nbsp;</span>
                        }
                    </div>
                </div>
                {project.projectType === 'konventionell'
                    ? <div className={"section-footer"} style={{borderBottom: 'none', paddingBottom: '5px'}}>
                        <div className="section-text" style={{width: 'calc(100% - 200px)'}}>
                            <div className={"row"} style={{display: 'flex', width: '100%'}}>
                                <div className={"col"}>*&nbsp;</div>
                                <div className={"col myjung1"}>{t(isMyJung ? 'app.pricebox.starText.konventionell.myjung' : 'app.pricebox.starText.konventionell') + ' '}
                                    {t(project.subProjectType !== 'neubau' ? 'app.pricebox.starText.konventionell.ending.other' : 'app.pricebox.starText.konventionell.ending.neubau')}
                                </div>
                            </div>
                        </div>
                        <div className="section-text"></div>
                        <div className="section-text"></div>
                    </div>
                    : <div className={"section-footer"}
                           style={{borderBottom: language === 'de' ? '1px solid var(--textColor)' : '1px solid transparent', paddingBottom: '5px'}}>
                        <div className={"section-text"} style={{
                            fontSize: '16px',
                            textAlign: 'left',
                            padding: '0',
                            margin: '0',
                            width: 'calc(100% - 200px)'
                        }}>
                            <div className={"row phoneNoShow"} style={{display: 'flex', width: '100%'}}>
                                <div className={"col myjung2"}>*&nbsp;</div>
                                <div className={"col myjung2"}>{t(isMyJung ? 'app.pricebox.starText.other.myjung' : 'app.pricebox.starText.other')}</div>
                            </div>
                        </div>
                    </div>}
                {project.projectType !== 'konventionell'
                    ? <div style={{display: language === 'de' ? 'block' : 'none'}}>
                        <div className={"section-header"}>
                            <div className={"section-title ppb"} style={{
                                width: 'auto',
                                marginBottom: '-10px',
                                marginTop: '10px',
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <span style={{display: 'inline'}}>{t('app.pricebox.financialSupport')}</span>
                                <TooltipWithButton props={{noActive: true, title: '', message: t('app.pricebox.financialSupport.info') }} />
                            </div>
                            <div className={"section-title hideMobile"}></div>
                        </div>
                        <div className={"section-body mobileColumn"}>
                            <div className={"section-text"} style={{position: 'relative', top: '0', flexGrow: '0'}}>
                                <div style={{display: 'inline-flex', flexDirection: 'row'}}>{t('app.pricebox.beg.smartFunctions')}&nbsp;&ndash;&nbsp;<a
                                    href="https://www.bafa.de/DE/Energie/Effiziente_Gebaeude/effiziente_gebaeude_node.html"
                                    target={"_blank"} rel={"noreferrer"} style={{color: 'var(--textColor)'}}>{t('app.pricebox.beg.smartFunctions.moreInfo')}</a></div>
                                { project.projectType === 'knx' ?
                                    <TooltipWithButton props={{noActive: true, title: t('app.pricebox.beg.smartFunctions.info.title'), message: t('app.pricebox.beg.smartFunctions.info.text.knx')}} />
                                    :
                                    <TooltipWithButton props={{noActive: true, title: t('app.pricebox.beg.smartFunctions.info.title'), message: t('app.pricebox.beg.smartFunctions.info.text')}} />
                                }
                                {checker(1)}
                            </div>
                            {1 === 3 ? <div className={"section-text"} style={{textAlign: 'center'}}>
                                <div>{t('app.pricebox.beg.heating')}</div>
                                <TooltipWithButton props={{noActive: true, title: '', message: t('app.pricebox.beg.heating.info')}} />
                                {checker(2)}
                            </div> : null}
                            <div className={"section-text"} style={{textAlign: 'right', marginRight: '-4px'}}>
                                <div style={{paddingLeft: '40px'}}>{t('app.pricebox.beg.renovation')}</div>
                                <TooltipWithButton props={{noActive: true, title: '', message: t('app.pricebox.beg.renovation.info')}} />
                                {checker(3)}<br/>
                            </div>
                            <div className={"section-text mobile-beg"}
                                 style={{color: 'var(--blueColor)'}}>{beg !== '0,00' ? '-' : ''} {beg} €&nbsp;&nbsp;&nbsp;&nbsp;</div>
                        </div>
                    </div> : null}
                {project.projectType !== 'konventionell'
                    ? <div className={"section-footer"} style={{display: language === 'de' ? 'flex' : 'none'}}>
                        <div
                            className={"section-text mobile-align-left title"}>{beg !== '0,00' ? t('app.pricebox.costs.with') : t('app.pricebox.costs.nowith')}</div>
                        <div className={"section-text mobile-align-right"} style={{
                            fontWeight: "bold",
                            width: '200px',
                            marginLeft: '0'
                        }}>{beg !== '0,00'
                            ? <NumberFormat value={isMyJung ? parseFloat(gesamtsumme.replace('.','').replace(',','.')) / (currentPercent + 1) : gesamtsumme}
                                            displayType={'text'} suffix={" €"}
                                            thousandSeparator={"."}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            decimalSeparator={","}/>
                            : <NumberFormat value={isMyJung ? parseFloat(gesamtsummeohnebeg.replace('.','').replace(',','.')) / (currentPercent + 1) : gesamtsummeohnebeg}
                                            displayType={'text'} suffix={" €"}
                                            thousandSeparator={"."}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            decimalSeparator={","}/>
                        }&nbsp;&nbsp;&nbsp;&nbsp;</div>
                    </div> : null}
                <div className={"section-footer phoneShow"}
                     style={{color: 'var(--textColor)', marginTop: '15px', paddingRight: '15px'}}>
                    {t(isMyJung ? 'app.pricebox.starText.other.myjung' : 'app.pricebox.starText.other')}
                </div>
            </div>;
        }
        if (props.justNotice) {
            return <div className={"section-footer phoneShow"} style={{color: 'var(--textColor)', margin: '0', padding: '15px'}}>
                {t(isMyJung ? 'app.pricebox.starText.other.myjung' : 'app.pricebox.starText.other')}
            </div>;
        }
        if (props.opener) {
            return <div className={"padding-container mobile-pricebox"}
                        style={{paddingBottom: "15px", paddingTop: '15px'}}>
                <div className={"section-header"}>
                    <div className={"section-title"} style={{
                        display: 'flex',
                        alignItems: 'center', whiteSpace: 'nowrap'
                    }}>{project.projectType === 'konventionell' ? t('app.pricebox.costs') : t('app.pricebox.costs')}
                        <TooltipWithButton props={{noActive: true, title: '', message: t(isMyJung ? 'app.pricebox.costs.info.myjung' : 'app.pricebox.costs.info')}} />
                    </div>
                    <div className={"section-title"}>
                        {project.projectType === 'konventionell'
                            ? <strong><NumberFormat value={isMyJung ? parseFloat(gesamtsummeohnebeg.replace('.','').replace(',','.')) / (currentPercent + 1) : gesamtsummeohnebeg}
                                                    displayType={'text'} suffix={" €*"}
                                                    thousandSeparator={"."}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    decimalSeparator={","}/>&nbsp;&nbsp;</strong>
                            : <span><NumberFormat value={isMyJung ? parseFloat(gesamtsummeohnebeg.replace('.','').replace(',','.')) / (currentPercent + 1) : gesamtsummeohnebeg}
                                                  displayType={'text'} suffix={" €*"}
                                                  thousandSeparator={"."}
                                                  decimalScale={2}
                                                  fixedDecimalScale={true}
                                                  decimalSeparator={","}/>&nbsp;&nbsp;</span>
                        }
                    </div>
                </div>
                {project.projectType !== 'konventionell'
                    ? <>
                        <div className={"section-header"} style={{flexDirection: 'column'}}>
                            <div className={"section-title ppb"} style={{
                                width: '100%',
                                marginBottom: '-20px',
                                marginTop: '10px',
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <span style={{display: 'inline'}}>{t('app.pricebox.financialSupport')}</span>
                                <TooltipWithButton props={{noActive: true, title: '', message: t('app.pricebox.financialSupport.info')}} />
                            </div>
                            <div className={"customOpener phoneShow" + (showFoerderung ? ' opened' : '')} style={{width: 'calc(100% - 10px)'}}>
                                <a href="/" onClick={(event) => {event.preventDefault(); setShowFoerderung(!showFoerderung); return false;} }>
                                    <FilterIcon2 />
                                    <div>{showFoerderung ? t('phone.button.close') : t('phone.button.edit')}</div>
                                </a>
                            </div>
                        </div>
                        {showFoerderung ? <>
                                <div className={"section-body mobileColumn"}>
                                    <div className={"section-text"}>
                                        <div style={{display: 'inline-flex', flexDirection: 'column'}}>{t('app.pricebox.beg.smartFunctions')}<br/><a
                                                href="https://www.bafa.de/DE/Energie/Effiziente_Gebaeude/effiziente_gebaeude_node.html"
                                                target={"_blank"} rel={"noreferrer"} style={{color: 'var(--textColor)'}}>{t('app.pricebox.beg.smartFunctions.moreInfo')}</a></div>
                                        { project.projectType === 'knx' ?
                                            <TooltipWithButton props={{noActive: true, title: t('app.pricebox.beg.smartFunctions.info.title'), message: t('app.pricebox.beg.smartFunctions.info.text.knx')}} />
                                            :
                                            <TooltipWithButton props={{noActive: true, title: t('app.pricebox.beg.smartFunctions.info.title'), message: t('app.pricebox.beg.smartFunctions.info.text')}} />
                                        }
                                        {checker(1)}
                                    </div>
                                    {1 === 2 ? <div className={"section-text"}>
                                        <div>{t('app.pricebox.beg.heating')}</div>
                                        <TooltipWithButton props={{noActive: true, title: '', message: t('app.pricebox.beg.heating.info')}} />
                                        {checker(2)}
                                    </div> : null}
                                    <div className={"section-text"}>
                                        <div>{t('app.pricebox.beg.renovation')}</div>
                                        <TooltipWithButton props={{noActive: true, title: '', message: t('app.pricebox.beg.renovation.info')}} />
                                        {checker(3)}
                                    </div>
                                    <div className={"section-text mobile-beg"}
                                         style={{color: 'var(--blueColor)'}}>{beg !== '0,00' ? '-' : ''} {beg} €&nbsp;&nbsp;&nbsp;&nbsp;</div>
                                </div>
                            </>
                            : null
                        }
                    </> : null}
                {project.projectType !== 'konventionell'
                    ? <div className={"section-footer"}>
                        <div
                            className={"section-text mobile-align-left title"}>{beg !== '0,00' ? t('app.pricebox.costs.with') : t('app.pricebox.costs.nowith')}</div>
                        <div className={"section-text mobile-align-right"} style={{
                            fontWeight: "bold"
                        }}><span>{beg !== '0,00'
                            ? <NumberFormat value={isMyJung ? parseFloat(gesamtsumme.replace('.','').replace(',','.')) / (currentPercent + 1) : gesamtsumme}
                                            displayType={'text'} suffix={" €"}
                                            thousandSeparator={"."}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            decimalSeparator={","}/>
                            : <NumberFormat value={isMyJung ? parseFloat(gesamtsummeohnebeg.replace('.','').replace(',','.')) / (currentPercent + 1) : gesamtsummeohnebeg}
                                            displayType={'text'} suffix={" €"}
                                            thousandSeparator={"."}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            decimalSeparator={","}/>
                        }&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        </div>
                    </div> : null}
            </div>;
        }
        return <></>;
    }
    // const ColorButton1 = withStyles((theme) => ({
    //     root: {
    //         color: "var(--weiss)",
    //         backgroundColor: "var(--grau3)",
    //         '&:hover': {
    //             backgroundColor:"var(--grau3)",
    //         },
    //         borderRadius: "8px",
    //         width: "143px",
    //         height: "45px",
    //         lineHeight: "45px",
    //         fontSize: "16px",
    //         textAlign: "center",
    //         margin: "20px",
    //         textTransform: "inherit"
    //     },
    // }))(Button);
    // const ColorButton2 = withStyles((theme) => ({
    //     root: {
    //         color: "var(--weiss)",
    //         backgroundColor: "var(--color1)",
    //         '&:hover': {
    //             backgroundColor:"var(--color1)",
    //         },
    //         borderRadius: 0,
    //         width: "143px",
    //         height: "45px",
    //         lineHeight: "45px",
    //         fontSize: "16px",
    //         textAlign: "center",
    //         margin: "20px",
    //         textTransform: "inherit"
    //     },
    // }))(Button);
    // const ColorButtonToTop = withStyles((theme) => ({
    //     root: {
    //         color: "var(--color2)",
    //         backgroundColor: "transparent",
    //         cursor: "pointer",
    //         borderRadius: 0,
    //         width: "auto",
    //         height: "45px",
    //         lineHeight: "45px",
    //         fontSize: "16px",
    //         fontWeight: "bold",
    //         textAlign: "center",
    //         margin: "-40px -10px 0 auto",
    //         textTransform: "inherit",
    //         border: "3px solid transparent",
    //         '&:hover': {
    //             backgroundColor: "transparent",
    //             color: "var(--color1)",
    //         },
    //         float: "right",
    //     },
    // }))(Button);
    function onSubmitHandler(e) {
        if (!(planungsCode || pCode)) {
            callFunction = 'submitForm';
            saveProject();
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    }
    function onSubmitHandler2(e) {
        if (!(planungsCode || pCode)) {
            callFunction = 'onSubmitHandler2';
            saveProject();
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
        if (!emailChecker) {
            console.log('no datenschutz');
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
        const planURL = window.location.host || process.env.REACT_APP_QUICK_SELF_URL || 'https://planung.fs-conf3-jung-dev.p14.de';
        const baseUrl = process.env.REACT_APP_QUICK_BACKEND_URL || 'https://fs-conf3-jung-dev.p14.de';
        const plancode = planungsCode ? planungsCode : pCode;

        if (sentCodes.includes(plancode)) {
            console.log('already sent');
            e.preventDefault();
            e.stopPropagation();
            return false;
        }

        let codeUrl = planURL;
        codeUrl += '/' + language + '/';
        switch (project.projectType) {
            case 'knx': codeUrl += 'knx-configurator';break;
            case 'home': codeUrl += 'home-configurator';break;
            default: codeUrl += 'switch-configurator';break;
        }
        codeUrl += '/' + plancode;
        const data = {
            subject: t('app.eml.'+project.projectType+'.subject') + ': ' + plancode,
            content: '<h1>'+t('app.eml.'+project.projectType+'.subject')+'</h1><br/><br/>'+
                '<p>'+t('app.eml.body.message') + ':</p>'+
                '<div>'+emailTextarea+'</div><br/><br/>'+
                '<p>'+t('app.eml.body.code') + ': <a href="'+codeUrl+'" target="_blank">'+plancode+'</a></p><br/><br/>' +
                '<p>'+t('app.eml.body.contactinfo') + ':<br/>'+
                t('app.step.konfigAnfrage.placeholder.vorname') + ': ' + emailVorname + '<br/>' +
                t('app.step.konfigAnfrage.placeholder.nachname') + ': ' + emailNachname + '<br/>' +
                t('app.step.konfigAnfrage.placeholder.rufnummer') + ': ' + emailRufnummer + '<br/>' +
                t('app.step.konfigAnfrage.placeholder.email') + ': ' + emailEmail + '</p>'
        };
        console.log('data to send', data, project)
        fetch(
            baseUrl + '/configurator-api/quickplaner/mail/'+language,
            {
                method: 'post',
                mode: "cors",
                body: JSON.stringify(data)
            }
        ).then(res => res?res.json():{})
            .then(result => {
                setSentCodes([...sentCodes, plancode]);
                console.log('successfully sent', result);
            }).catch(e => console.log('tracking post error', e))
            .finally(() => {
                setSentCodes([...sentCodes, plancode]);
                setSentDialogIsOpened(true);
            });
        e.preventDefault();
        e.stopPropagation();
        return false;
    }
    function submitForm() {
        ProjectSaveService.saveTracking({
            trackingId: trackingObj.trackingId,
            merchant: 1
        }, null,isOldUrl,language, trackingObj);
        setTimeout(() => {
            // partnerForm.dispatchEvent(new Event('submit', { cancelable: true }));
            document.getElementById('btnSubmit').click();
        }, 100);
    }
    function getProjectType(){
        return project.projectType.replace('konventionell', 'schalter');
    }
    function getPlanungsCode() {
        return '' + (pCode || planungsCode || prCode);
    }
    // function GetArrowForwardIcon() {
    //     return <img src={downloadIcon} width="20" alt={"download"} />;
    // }
    function sendElbridge() {
        if (!planungsCode && !pCode) {
            pCodeIntervalElbridge = setInterval(checkCodeElbridge, 500);
            saveProject();
            return;
        }
        let sendItem = {
            CONFIGURATION_URL: window.location.href,
            ITEM: [],
        };
        productListAndFilters.productList.map(lst => {
            lst.products.map(p => {
                sendItem.ITEM.push({
                    SUPPLIER_ID_GLN: "" + p.SUPPLIER_ID_GLN, //p.Gtin,
                    MANUFACTURER_PID: "" + p.Artikelnummer,
                    QUANTITY: "" + p.count,
                    ORDER_UNIT: "C62"
                });
                return p;
            });
            return lst;
        });
        let form = document.createElement('form');
        form.setAttribute('target', '_blank');
        form.setAttribute('method', 'POST');
        form.setAttribute('action', 'https://interface.elbridge2.itek.de/');

        let inputEl = document.createElement("input");
        inputEl.setAttribute('type', 'text');
        inputEl.setAttribute('name', 'version');
        inputEl.setAttribute('value', '2.0');
        form.appendChild(inputEl);

        let inputData = document.createElement("input");
        inputData.setAttribute('type', 'text');
        inputData.setAttribute('name', 'result');
        inputData.setAttribute('value', JSON.stringify(sendItem));
        form.appendChild(inputData);

        console.log('sendItem', sendItem)

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
        ProjectSaveService.saveTracking({
            trackingId: trackingObj.trackingId,
            elbridgeUsed: 1
        }, null, trackingObj);
    }
    // function onCaptchaChange(value) {
    //     console.log("Captcha value:", value);
    // }
    function handleEmailTextareaChange(e) {
        // setEmailTextarea(e.target.value.split('\n').map((item, key) => {
        //     console.log('maping ', item, key)
        //     return '<span>' + (item !== ','?item:'') + '<br/></span>';
        // }));
        setEmailTextarea(e.target.value.split('\n').join('<br/>'));
    }
    function handleEmailVornameChange(e) {
        setEmailVorname(e.target.value);
    }
    function handleEmailNachnameChange(e) {
        setEmailNachname(e.target.value);
    }
    function handleEmailRufnummerChange(e) {
        setEmailRufnummer(e.target.value);
    }
    function handleEmailEmailChange(e) {
        setEmailEmail(e.target.value);
    }
    function handleEmailCheckerChange(e) {
        setEmailChecker(e.target.checked);
    }
    function handleDialogClose(){
        setSentDialogIsOpened(false);
    }
    function handleInfoClose(){
        setUserInfoOpen(false);
        setUserInfoPage(1);
    }

    const BtnProjektBoerse = withStyles((theme) => ({
        root: {
            color: "var(--weiss)",
            backgroundColor: "var(--blueColor)",
            '&:hover': {
                backgroundColor:"var(--blueColor)",
            },
            borderRadius: 0,
            height: "45px",
            lineHeight: "45px",
            fontSize: "inherit",
            textAlign: "center",
            padding: "10px",
            flex: 1,
            textTransform: "inherit"
        },
    }))(Button);
    const BtnProjektBoerse2 = withStyles((theme) => ({
        root: {
            color: "var(--weiss)",
            backgroundColor: "#001dec",
            '&:hover': {
                backgroundColor:"var(--blueColorHover)",
            },
            borderRadius: "20px !important",
            height: "33px",
            lineHeight: "33px",
            fontSize: "inherit",
            textAlign: "center",
            padding: "0 15px !important",
            flex: 1,
            textTransform: "inherit"
        },
    }))(Button);
    const BtnProjektBoerse3 = withStyles((theme) => ({
        root: {
            color: "var(--blueColor)",
            backgroundColor: "white",
            '&:hover': {
                backgroundColor:"var(--blueColor)",
                color:"white"
            },
            '&.active': {
                backgroundColor:"var(--blueColor)",
                color:"white"
            },
            borderRadius: "4px !important",
            height: "36px",
            lineHeight: "36px",
            fontSize: "inherit",
            textAlign: "center",
            padding: "0 15px !important",
            flexGrow: 0,
            textTransform: "inherit",
            width:'auto',
            marginRight:'15px',
            border:'1px solid var(--blueColor)'
        },
    }))(Button);
    function toggleProjektboerse(e) {
        if (!boerseOpen) {
            setBoersePage(1);
        }
        setBoerseOpen(!boerseOpen);
    }
    function handleSendProjektmanagerOpen(e) {
        if (prCode && !pCode) { pCode = prCode; }
        if (!planungsCode && !pCode) {
            callFunction = 'handleSendProjektmanagerOpen';
            console.log('calling save project')
            saveProject();
            console.log('save project called, exiting handleSendProjekmanagerOpen')
            return;
        }
        //setUserInfoOpen(true);
        console.log('calling handleUserInfoSubmit')
        handleUserInfoSubmit(e);
        console.log('handleUserInforSubmit called, exiting handleSendProjetmanagerOpen')
        if (e) { e.preventDefault();e.stopPropagation(); }
        return false;
    }
    function handleBoerseClose(e) {
        e.preventDefault(); e.stopPropagation();
        setBoerseOpen(false);
        return false;
    }
    function formatDate() {
        let d = new Date(),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }
    function getDetails() {
        const productList = productListAndFiltersAll.productList;
        const list = [];
        let str = '[';

        productList.forEach( g => {
            g.products.filter(i => i.Preis >= 0).forEach(p => {
                list.push({
                    menge:p.count,einheit:"Stück",beschreibung:p.Bezeichnung,
                    artikelnummer:p.Artikelnummer,gtin:p.Gtin,
                    einzelpreis:parseInt(p.Preis,10),
                    gesamtpreis:parseInt(p.Preis,10)*p.count
                });
                if (str.length > 1) { str += ','; }
                str += '{"menge":'+p.count+',"einheit":"Stück","beschreibung":'+p.Bezeichnung+',"artikelnummer":'+p.Artikelnummer+',"gtin":'+p.Gtin+
                    ',"einzelpreis":'+parseInt(p.Preis,10)+',"gesamtpreis":'+(parseInt(p.Preis,10)*p.count)+'}'
            });
        });
        str +=']';
        return list;
    }
    function gotLogin(data, response) {
        // console.log('got response', response);
        if (response.token) {
            setCurrentToken(response.token);
            prepareBoerseData(data, response);
        }
    }
    function handleBoerseSubmit(event) {
        event.preventDefault(); event.stopPropagation();
        if (!planungsCode && !pCode) {
            callFunction = 'submitBoerseForm';
            saveProject();
            return false;
        }
        ProjectBoerseService.sendLogin(event.target.elements, gotLogin);
        return false;
    }
    function sendBoerseForm(e) {
        document.getElementById('boerseForm').requestSubmit();
    }
    function toggleProjektort(e) {
        e.preventDefault();e.stopPropagation();
        setProjektOrt(!projektOrt);
        return false;
    }
    function sendBoerseResult(response, token = null) {
        console.log('boerseresult', response);
        if (response.violations) {
            for (let i = 0; i < response.violations.length; i++) {
                const violation = response.violations[i];
                document.getElementById(violation.propertyPath).style.border = '1px solid #dc3545';
                document.getElementById(violation.propertyPath + "_error").innerHTML = violation.message;
            }
            return false;
        }
        setBoersePage(2);
    }
    function prepareBoerseData(formData, response) {
        // console.log('formdata', formData)
        // setTimeout(() => {sendBoerseResult({'@id': '/api/projekt/018cc97f-6b4c-7f41-87d7-9a64c4ae1982'}, response.token)}, 1000);
        // return;
        const projectType = response.projectType[0];
        const werte = [];
        projectType.zusaetzlicheProjektEigenschaften.forEach(zpe => {
            switch (zpe.name) {
                case 'Art der Baustelle':
                    werte.push({ // art der baustelle, ex. Mehrfamillienhaus
                        projektEigenschaft: zpe['@id'],
                        value: project.name
                    });
                    break;
                case 'Gebäude-Typ':
                    werte.push({ // gebaeude-typ, ex. Neubau
                        projektEigenschaft:zpe['@id'],
                        value: project.subProjectType === 'neubau' ? 'Neubau' : 'Umbau im Bestand'
                    });
                    break;
                case 'Projektname':
                    werte.push({ // projektname, ex. Neubau Haus smart zu machen
                        projektEigenschaft: zpe['@id'],
                        value: project.projectName !== '' ? project.projectName : project.name
                    });
                    break;
                case 'PLanungslink für myJUNG-Accountinhaber':
                    werte.push({ // myJung planungslink
                        projektEigenschaft: zpe['@id'],
                        value: 'https://' + window.location.host + '/home/myjung/' + (planungsCode ? planungsCode : pCode)
                    });
                    break;
                case 'Öffentlicher Planungslink':
                    werte.push({ // oeffentlicher planungslink
                        projektEigenschaft: zpe['@id'],
                        value: 'https://' + window.location.host + '/home/' + (planungsCode ? planungsCode : pCode)
                    });
                    break;
                case 'JUNG Projektmanager':
                    werte.push({ // projektmanager planungslink
                        projektEigenschaft: zpe['@id'],
                        value: 'https://' + (process.env.REACT_APP_PROJEKTMANAGER_URL || 'schalter.jung-configurator.com') + '/projekt-eigenschaften?pc=' + (planungsCode ? planungsCode : pCode)
                    });
                    break;
                default: break;
            }
        });
        const gewerke = [];
        response.gewerke.forEach(g => gewerke.push(g['@id']));
        const sendData = {
            titel: project.projectName !== '' ? project.projectName : project.name,
            untertitel: 'Gesucht: Handwerker/in zur Schadenssanierung',
            extReferenzId: planungsCode ? planungsCode : pCode,
            umsatzpotenzial: parseInt(totals.gesamtsummeohnebeg.replace('.','').replace(',',''),10),
            strasse: formData.differentAddress.checked ? formData.strasse.value : formData.kontaktStrasse.value,
            hausnummer: formData.differentAddress.checked ? formData.hausnummer.value : formData.kontaktHausnummer.value,
            plz: formData.differentAddress.checked ? formData.plz.value : formData.kontaktPlz.value,
            ort: formData.differentAddress.checked ? formData.ort.value : formData.kontaktOrt.value,
            kontaktAnrede: formData["gender[]"].value,
            kontaktVorname: formData.kontaktVorname.value,
            kontaktNachname: formData.kontaktNachname.value,
            kontaktEmail: formData.kontaktEmail.value,
            kontaktStrasse: formData.kontaktStrasse.value,
            kontaktHausnummer: formData.kontaktHausnummer.value,
            kontaktPlz: formData.kontaktPlz.value,
            kontaktOrt: formData.kontaktOrt.value,
            projektTyp: projectType['@id'], // "/api/projekt_typen/018cb05a-8d16-71cb-929f-f4dc8f08cb9a",
            projektEigenschaftWerte: werte,
            qualifikationen: [],
            gewerke: gewerke,
            projektArt: "Angebot",
            beschreibung: "Bei diesem Projekt handelt es sich um ein JUNG HOME Projekt. Der gewünschte Umfang wird in den Planungsunterlagen beschrieben (siehe Planungslink).",
            details: getDetails(),
            projektStart: formatDate() + "T08:00:00.000Z",
            deadline:"2025-05-30T17:00:00.000Z"
        };
        ProjectBoerseService.sendProject(sendData, response.token, sendBoerseResult);
    }
    function getDomain(){
        return process.env.REACT_APP_QUICK_BACKEND_URL || 'https://fs-conf3-jung-dev.p14.de';
    }
    function handleUserInfoSubmit(e) {
        if (e) { e.preventDefault(); e.stopPropagation(); }
        const pTypes = {'knx': 'KNX', 'home': 'Home', 'konventionell': 'Switch'};
        // const prname = document.getElementById('projekt_properties_form_projektname').value;
        const prname = project.projectName !== '' ? project.projectName : project.name;
        let structure = currentProject.combinations.items;
        console.log('handleUserInfoSubmit', project, currentProject, prCode, pCode, getPlanungsCode())
        const dataPM = {
            name: prname, //project.projectName !== '' ? project.projectName : project.name,
            projectType: pTypes[project.projectType],
            projectNr: '', //document.getElementById('projekt_properties_form_projektNr').value,
            contact: {
                salutation: '', //document.getElementById('projekt_properties_form_anrede').value,
                firstname: '', //document.getElementById('projekt_properties_form_vorname').value,
                lastname: '', //document.getElementById('projekt_properties_form_name').value,
                company: '', //document.getElementById('projekt_properties_form_firma').value,
                street: '', //document.getElementById('projekt_properties_form_strasse').value,
                street_nr: '', //document.getElementById('projekt_properties_form_strNr').value,
                plz: '', //document.getElementById('projekt_properties_form_plz').value,
                city: '', //document.getElementById('projekt_properties_form_ort').value
            },
            // projectDescription: document.getElementById('projekt_properties_form_projektBeschreibung').value,
            structure: structure,
            market: i18n.resolvedLanguage.toUpperCase()
        };
        let projectPro = currentProject.projectPro || currentProject.generatedProject;
        projectPro = {...projectPro, name: project.projectName && project.projectName !== '' ? project.projectName : project.name};
        if (!projectPro) { projectPro = currentProject.generatedProject; }
        projectPro = {...projectPro, code: getPlanungsCode()};
        setTimeout(() => {
            fetch(
                getDomain() + "/configurator-api/quickplaner/save" + (!isOldUrl ? ('/' + i18n.resolvedLanguage) : ''),
                {
                    method: "post",
                    mode: "cors",
                    body: JSON.stringify({
                        version: '0.1',
                        dataP: prname !== projectPro.name ? {...projectPro, name: prname} : projectPro,
                        dataQ: prname !== project.projectName ? {
                            ...project,
                            name: prname,
                            projectName: prname
                        } : project,
                        code: getPlanungsCode(), //prCode,
                        dataPM: dataPM,
                    })
                }
            ).then(res => res.json()).then(result => {
                // const prname = ''; //document.getElementById('projekt_properties_form_projektname').value;
                // if (prname !== project.projectName) {
                //     updateProject({
                //         ...project,
                //         projectName: document.getElementById('projekt_properties_form_projektname').value
                //     });
                // }
                // setUserInfoPage(2);
                let url = process.env.REACT_APP_PROJEKTMANAGER_URL || 'https://pm-qm.jung-configurator.com/en-INTWEB/project-manager/projekt-von-code/';
                if (url.substring(url.length - 1) !== '/') {
                    url += '/';
                }
                window.open(url + getPlanungsCode(), '_blank')
            }).catch(console.log);
        }, 100);
        return false;
    }
    function saveUserInfo(e) {
        e.preventDefault(); e.stopPropagation();
        handleUserInfoSubmit(e);
        return false;
    }
    function btnclick() {
        project.isMyJung = true;
        isMyJung = true;
        setValueIsMyJung(true);
    }
    function handleProjectNameChange(e) {
        setPrname(e.target.value);
        console.log('new Projektname', prname)
    }
    function handleProjectCodeClick(e) {
        e.preventDefault();e.stopPropagation();
        // console.log('handleprojectcodeclick')
        // setUserInfoOpen(true);
        return false;
    }
// console.log('project',project, currentProject)
    return <>
        <div className={"last-page-container pb-15"}>
            <div className={"padding-container"}>
                <div className={"border-bottom pb-15 mb-15"}>
                    <div className={"section-title"} style={{marginBottom: '5px'}}>{t('app.step.productlist.title')}</div>
                    <div className={"section-text"}>{t('app.step.productlist.description')}</div>
                </div>
                <div className="equimentBoxHeader" onClick={(e) => onOpenClose(e)}>
                    <div className="openClose">
                        {isOpen ? <CircleButton>
                            <img className="icon-to-page-bottom" src={uarrh} alt={""} width="25" style={{marginRight: "-22px"}} />
                            <img className="icon-to-page-bottom only-hover" src={uarrh} alt={""} width="25"/>
                        </CircleButton> : <CircleButton>
                            <img className="icon-to-page-bottom" src={darrh} alt={""} width="25" style={{marginRight: "-22px"}} />
                            <img className="icon-to-page-bottom only-hover" src={darrh} alt={""} width="25"/>
                        </CircleButton> }
                    </div>
                    <span className={"section-text"} style={{fontWeight: "bold", marginLeft: "5px", paddingTop: '0'}}>{isOpen ? t('app.button.hide.productlist') : t('app.button.show.productlist')}</span>
                </div>
                {isOpen ? <div className={"step5SelectWrapper filterWrapper row"}>
                    <div className={"step5SelectItem col-1"}>
                        <Select defaultValue="alle" id="grouped-select-room" style={{display:"block"}}>
                            {generateRoomFilter(productListAndFilters.roomFilterList)}
                        </Select>
                    </div>
                    <div className={"step5SelectItem col-1"}>
                        <Select defaultValue={"productFilter-all"} id="grouped-select-product" style={{display:"block"}}>
                            {generateProductFilter(productListAndFilters.catFilterList, productListAndFilters.isAllRooms)}
                        </Select>
                    </div>
                </div> : null}
                <div className={"product-list-opened"}>
                {isOpen ? <>
                        {(!productListAndFilters.isAllRooms ? <>{generateGroupList()}</> : <>{generateRoomList()}</>)}
                        <div className="equimentBoxHeader" onClick={onOpenClose} style={{marginTop: '15px'}}>
                            <div className="openClose">
                                {isOpen ? <CircleButton>
                                    <img className="icon-to-page-bottom" src={uarrh} alt={""} width="25" style={{marginRight: "-22px"}} />
                                    <img className="icon-to-page-bottom only-hover" src={uarrh} alt={""} width="25"/>
                                </CircleButton> : <CircleButton>
                                    <img className="icon-to-page-bottom" src={darrh} alt={""} width="25" style={{marginRight: "-22px"}} />
                                    <img className="icon-to-page-bottom only-hover" src={darrh} alt={""} width="25"/>
                                </CircleButton> }
                            </div>
                            <span className={"section-text"} style={{fontWeight: "bold", marginLeft: "5px", paddingTop: '0'}}>{isOpen ? t('app.button.hide.productlist') : t('app.button.show.productlist')}</span>
                        </div>
                    </>
                    : null}
                </div>
            </div>
        </div>
        {project.projectType === 'home' ? <div className={"fs-container mt-15 ptb-25"}>
            <div className={"padding-container"}>
                <div className={"border-bottom pb-15 mb-15"}>
                    <div className={"section-title"} style={{marginBottom: '5px'}}>{t('app.step.featureList')}</div>
                </div>
                <div className="equimentBoxHeader" onClick={onFunktionenToggle}>
                    <div className="openClose">
                        {isFunktionenOpen ? <CircleButton>
                            <img className="icon-to-page-bottom" src={uarrh} alt={""} width="25" style={{marginRight: "-22px"}} />
                            <img className="icon-to-page-bottom only-hover" src={uarrh} alt={""} width="25"/>
                        </CircleButton> : <CircleButton>
                            <img className="icon-to-page-bottom" src={darrh} alt={""} width="25" style={{marginRight: "-22px"}} />
                            <img className="icon-to-page-bottom only-hover" src={darrh} alt={""} width="25"/>
                        </CircleButton> }
                    </div>
                    <span className={"section-text"} style={{fontWeight: "bold", marginLeft: "5px", paddingTop: '0'}}>{isOpen ? t('app.button.show.featureList') : t('app.button.hide.featureList')}</span>
                </div>
                {isFunktionenOpen ? <>
                    {Object.keys(currentProject.functionsCats).length
                        ? <div className={"step5SelectWrapper filterWrapper row phone-small"}>
                            <div className={"step5SelectItem col-1"} style={{maxHeight: '45px', padding: '0 10px'}}>
                                <Select defaultValue="functionsFilter-all" id="grouped-select-room" style={{display:"block", paddingTop: '8px'}}>
                                    {generateFunktionenFilter()}
                                </Select>
                            </div>
                            <div className={"step5SelectItem col-1"} style={{maxHeight: '45px', background: 'transparent',}}></div>
                            <div className={"step5SelectItem col-1"} style={{maxHeight: '45px', background: 'transparent', padding: '0 10px'}}>
                                <ColorButton4 type="submit" onClick={downloadFunctions} style={{width: '100%', marginTop: '0', borderRadius: '5px'}}>{getFunctionsButtonLabel()}</ColorButton4>
                            </div>
                        </div>
                        : <>
                            <div style={{padding: '30px 0 15px', color: 'var(--textColor)'}}>{t('app.step.featureList.noRecords')}</div>
                        </>
                    }
                </> : null}
                <div className={"product-list-opened"}>
                {isFunktionenOpen && Object.keys(currentProject.functionsCats).length ? <>
                    <div className="equimentBoxHeader" style={{width: '100%', flexDirection: 'column', marginTop: '15px'}}>
                        <div className={"row"} style={{width: '100%', color: 'var(--textColor)', paddingBottom: '15px'}}>
                            <div className={"col-1 phoneNoShow"} style={{minWidth: '95px', textAlign: "right"}}>{t('app.table.application')}</div>
                            <div className={"col-2 phone-plr-10"} style={{textAlign: "center"}}>{t('app.table.area')}</div>
                            <div className={"col-2 phoneNoShow"} style={{textAlign: "center"}}>{t('app.table.title')}</div>
                            <div className={"col-7 phone-talign-left"} style={{textAlign: "center"}}>{t('app.table.function')}</div>
                        </div>
                        {<GenerateFilteredFunctionen />}
                    </div>
                    <div className="equimentBoxHeader" onClick={onFunktionenToggle} style={{marginTop: '15px'}}>
                        <div className="openClose">
                            {isFunktionenOpen ? <CircleButton>
                                <img className="icon-to-page-bottom" src={uarrh} alt={""} width="25" style={{marginRight: "-22px"}} />
                                <img className="icon-to-page-bottom only-hover" src={uarrh} alt={""} width="25"/>
                            </CircleButton> : <CircleButton>
                                <img className="icon-to-page-bottom" src={darrh} alt={""} width="25" style={{marginRight: "-22px"}} />
                                <img className="icon-to-page-bottom only-hover" src={darrh} alt={""} width="25"/>
                            </CircleButton> }
                        </div>
                        <span className={"section-text"} style={{fontWeight: "bold", marginLeft: "5px", paddingTop: '0'}}>{t('app.button.hide.functions')}</span>
                    </div>
                </>
                : null}
                </div>
            </div>
        </div> : null}
        {window.innerWidth < 800 ? <PriceBox opener={true} /> : null}
        {/*<div className={"fs-container ptb-25" + (project.projectType !== 'konventionell' ? ' mt-15' : '')}>*/}
        {/*    <div className="padding-container p40">*/}

        {/*    </div>*/}
        {/*</div>*/}
        <div className="fs-container mt-15 ptb-25">
            <div className="padding-container p40">
                <div className="row planungscode">
                    <div className="col-6" style={{display: 'flex', flexDirection: 'column'}}>
                        <div className="section-title">{t('app.step.documents.title')}</div>
                        <div className="section-text mb-15" style={{flexGrow:1}}>{t('app.step.documents.description')}</div>
                        <div className={"exportButtons"}>
                            {project.isMyJung ? <ColorButton4 onClick={downloadCSV}>{getCSVButtonLabel()}</ColorButton4> : null}
                            {project.projectType === 'home' ? <>
                                {Object.keys(currentProject.functionsCats).length
                                    ? <ColorButton4 type="submit" onClick={downloadFunctions}>{getFunctionsButtonLabel()}</ColorButton4>
                                    : <ColorButton4Disabled type="submit">{getFunctionsButtonLabel()}</ColorButton4Disabled>
                                }
                            </> : null}
                            <ColorButton4 type="submit" onClick={downloadPdf}>{getRoomBookButtonLabel()}</ColorButton4>
                            {!isProduction ? <button onClick={btnclick} style={{opacity:0.01}}>X</button> : null}
                        </div>
                    </div>
                    <div className="col-6 pl45px" style={{display:'flex',flexDirection:'column'}}>
                        <div className="section-title">{t('app.step.planningCode.title')}</div>
                        <div className="section-text mb-15" dangerouslySetInnerHTML={{__html: t('app.step.planningCode.description')}} style={{flexGrow:1}}></div>
                        <div className={"exportButtons"}>
                            <div className={"col"}>
                                { planungsCode || pCode || prCode ?
                                    <>
                                        <div style={{position: "relative", fontSize: '20px', color: 'var(--captionColor)', top: "5px"}}>
                                            <a className={"bold"} href={""} onClick={e => {handleProjectCodeClick(e);}} style={{textDecoration:'none'}}>{prCode ? prCode : (planungsCode ? planungsCode : pCode)}</a>
                                            <CopyIconSVG/>
                                            {inClipboard ? <InClipboardNotice/> : null}
                                        </div>
                                    </>
                                    : <div style={{textAlign: "center", width: 'calc(100% - 10px)'}} className="justmobilearrow">
                                        <ColorButton41 onClick={e => saveProject(isProjektboerse ? true : false)}>
                                            {t('app.button.generateCode')}
                                            <svg xmlns="http://www.w3.org/2000/svg" width="33" height="30" viewBox="0 0 33 30">
                                                <g transform="translate(1226 294.034) rotate(180)">
                                                    <rect width="33" height="30" transform="translate(1193 264.034)" fill="transparent"/>
                                                    <path d="M12.859,8.077l.679.679a.731.731,0,0,1,0,1.037L7.6,15.738a.731.731,0,0,1-1.037,0L.613,9.792a.731.731,0,0,1,0-1.037l.679-.679a.735.735,0,0,1,1.049.012l3.511,3.686V2.984a.732.732,0,0,1,.734-.734h.979a.732.732,0,0,1,.734.734v8.79L11.81,8.089A.73.73,0,0,1,12.859,8.077Z" transform="translate(1202.715 269.608)" fill="#fff"/>
                                                </g>
                                            </svg>
                                        </ColorButton41>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/*Projekt Manager DE, AT, NL MyJung*/}
        {showProjektmanager && ['de', 'at', 'nl'].includes(language) ? <>
            <div className="fs-container mt-15 ptb-25" id={"send_boersecontainer"} style={{position:'relative',overflow:'hidden'}}>
                <div className="padding-container p40">
                    <div className="col-6" style={{paddingLeft: '20%'}}>
                        <img src={jungPMBanner} height="100%" className={"pm-banner"} alt={"banner"} />
                    </div>
                    <div className="row planungscode" style={{position:'relative'}}>
                        <div className="col-6" style={{display: 'flex', flexDirection: 'column', maxWidth: '63%', marginLeft: 'auto', marginRight: '0'}}>
                            <div className="section-title">{t('app.projektmanager.title')}</div>
                            <div className="section-text mb-15">{t('app.projektmanager.line1')}<br/>{t('app.projektmanager.line2')}<br/><a style={{color:'var(--blueColor)',textDecoration:'none',display: 'block',marginTop:'5px',width:'max-content'}} href={"https://www.jung-learning.com/ilp/pages/description.jsf?menuId=1107&designMenuId=1107#/users/@self/catalogues/117028/courses/190167/description"} target={"_blank"} rel="noreferrer">{t('app.projektmanager.linktext')}</a></div>
                            <div className={"exportButtons"} style={{paddingLeft:'40%'}}>
                                {<BtnProjektBoerse onClick={(e) => handleSendProjektmanagerOpen(e)}>{t('app.projektmanager.buttonText')}</BtnProjektBoerse>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>: null}
        {/*JUNG Fachpartner finden*/}
        {!isMyJung  && !['at','nl','es'].includes(language) ? <div className="fs-container mt-15 p0 last-banner">
            <div className={"col-12"}>
                <div className={"lastbanner"}>
                    <img className={"bannerimage"} alt="people" src={peopleImg} width="435px" />
                    <form id={"partnerform"} action={process.env.REACT_APP_QUICK_FIND_PARTNER_URL} method="post" target={"_blank"} rel="noreferrer" onSubmit={onSubmitHandler} ref={ref => setPartnerForm(ref)}>
                        <input type={"hidden"} name={"project_code"} value={getPlanungsCode()}/>
                        <input type={"hidden"} name={"project_source"} value={getProjectType()}/>
                        <input type={"hidden"} name={"token"} value={currentSha1} />
                        <div className={"form"}>
                            <div className={"section-title"}>{t('app.step.fachpartner.title')}</div>
                            <div className={"section-text"}>{t('app.step.fachpartner.description')}</div>
                            <div className={"form-row"}>
                                <div className={"section-text only-mobile"}>{t('app.step.fachpartner.plz')}</div>
                                <input name={"place"} placeholder={t('app.step.fachpartner.plz')} />
                                <ColorButton42 className={"btn-send"} type={"submit"} id={"btnSubmit"}>
                                    <span>{t('app.step.fachpartner.search')}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="30" viewBox="0 0 33 30">
                                        <g transform="translate(1226 294.034) rotate(180)">
                                            <rect width="33" height="30" transform="translate(1193 264.034)" fill="transparent"/>
                                            <path d="M12.859,8.077l.679.679a.731.731,0,0,1,0,1.037L7.6,15.738a.731.731,0,0,1-1.037,0L.613,9.792a.731.731,0,0,1,0-1.037l.679-.679a.735.735,0,0,1,1.049.012l3.511,3.686V2.984a.732.732,0,0,1,.734-.734h.979a.732.732,0,0,1,.734.734v8.79L11.81,8.089A.73.73,0,0,1,12.859,8.077Z" transform="translate(1202.715 269.608)" fill="#fff"/>
                                        </g>
                                    </svg>
                                </ColorButton42>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div> : null}
        {/*JUNG Fachpartner finden nl, fr, es*/}
        {!isMyJung && (!isProjektboerse || showProjektboerse) && ['at','nl','es'].includes(language) ? <div className="fs-container mt-15 p0 last-banner">
            <div className={"col-12"}>
                <form id={"partnerform"} action={process.env.REACT_APP_QUICK_FIND_PARTNER_URL} method="post" target={"_blank"} rel="noreferrer" onSubmit={onSubmitHandler2} ref={ref => setPartnerForm(ref)}>
                <div className={"lastbanner konfig-anfrage"} style={{alignItems:'center'}}>
                    <img className={"bannerimage"} alt="people" src={peopleImg} width="50%" />
                    <input type={"hidden"} name={"token"} value={currentSha1} />
                    <div className={"form"} style={{padding:'0 10% 0 30px',maxWidth:'50%',fontSize:'22px',lineHeight:'28px'}}>
                        <div className={"section-title"}>{t('app.step.konfigAnfrage.title')}</div>
                        <div className={"section-text"} style={{fontSize:'22px'}}>{t('app.step.konfigAnfrage.description')}</div>
                    </div>
                </div>
                <div className={"konfig-anfrage-form"}>
                    <div className={"left"}>
                        <div className={"section-title"} style={{fontSize:'22px'}}>{t('app.step.konfigAnfrage.leftTitle')}</div>
                        <div className={"section-text"} style={{position:'relative', marginBottom:'15px'}}>
                            <strong style={{flexGrow: 1}}>{t('app.step.konfigAnfrage.msgTitle')}</strong>
                            <TooltipWithButton props={{absolutePosition: true, noActive: true, title: '', message: 'Text fehlt', marginLeft: 'auto'}} />
                        </div>
                        <textarea name={"messageBody"} id={"messageBody"}
                                  placeholder={t('app.step.konfigAnfrage.placeholder')} rows={"9"} style={{width:'100%'}}
                                  onChange={handleEmailTextareaChange}
                        >{t('app.step.konfigAnfrage.placeholder')}</textarea>
                        <div className={"konfig-code"} style={{marginBottom: '30px'}}>
                            <div className={"section-text"} style={{marginBottom: '15px'}}><strong>{t('app.step.konfigAnfrage.konfigCodeTitle')}</strong></div>
                            {planungsCode || pCode || prCode
                                ?<div className={"konfig-code-text"} style={{borderBottom: '1px solid'}}>{planungsCode || pCode || prCode}</div>
                                :<div className={"konfig-code-text"} style={{borderBottom: '1px solid'}}>&nbsp;</div>
                            }
                        </div>
                    </div>
                    <div className={"right"}>
                        <div className={"section-title"} style={{marginBottom: '25px',fontSize:'22px'}}>{t('app.step.konfigAnfrage.rightTitle')}</div>
                        <input required={"required"} type={"text"} className={"konfig-input"} name={"konfig-vorname"} id={"konfig-vorname"} placeholder={t('app.step.konfigAnfrage.placeholder.vorname')} onChange={handleEmailVornameChange} />
                        <input required={"required"} type={"text"} className={"konfig-input"} name={"konfig-nachname"} id={"konfig-nachname"} placeholder={t('app.step.konfigAnfrage.placeholder.nachname')} onChange={handleEmailNachnameChange} />
                        <input required={"required"} type={"text"} className={"konfig-input"} name={"konfig-rufnummer"} id={"konfig-rufnummer"} placeholder={t('app.step.konfigAnfrage.placeholder.rufnummer')} onChange={handleEmailRufnummerChange} />
                        <input required={"required"} type={"text"} className={"konfig-input"} name={"konfig-e-mail"} id={"konfig-e-mail"} placeholder={t('app.step.konfigAnfrage.placeholder.email')} onChange={handleEmailEmailChange} />
                    </div>
                </div>
                <div className={"konfig-anfrage-form gcaptcha"} style={{paddingLeft:'30px'}} id={"grccontainer"}>
                    <GoogleReCaptchaProvider reCaptchaKey="6LdvlU0qAAAAABgSja4P7kS_CUNeBkwO1XMEYQUv" container={"grccontainer"}>
                        {/*<GoogleReCaptcha*/}
                        {/*    className="google-recaptcha-custom-class"*/}
                        {/*    onVerify={setTokenFunc}*/}
                        {/*    refreshReCaptcha={refreshReCaptcha}*/}
                        {/*/>*/}
                    </GoogleReCaptchaProvider>
                </div>
                <div className={"konfig-anfrage-form checker"} style={{paddingLeft:'30px',display:'flex',flexDirection:'column',paddingTop:'30px'}}>
                    <label style={{display:'flex',alignItems:'center'}}>
                        <input required={"required"} type={"checkbox"} name={"konfig-datenschutz"} id={"konfig-datenschutz"} style={{marginRight:'5px',marginLeft:'0'}} onChange={handleEmailCheckerChange} /> {t('app.step.konfigAnfrage.datenschutz')}
                    </label>
                    <div className={"datenschutz"}>{t('app.step.konfigAnfrage.datenschutzText')}</div>
                    <div className={"datenschutz"} style={{marginTop:'15px'}}>{t('app.step.konfigAnfrage.datenschutzTextHinweis')}</div>
                </div>
                <div className={"konfig-anfrage-form actions"} style={{paddingLeft:'30px',display:'flex',alignItems:'flex-end',flexDirection:'column',paddingTop:'30px'}}>
                    {sentCodes.includes(pCode) || sentCodes.includes(planungsCode) || sentCodes.includes(prCode) ?
                        <ColorButton4 className={"btn-send"} type={"submit"} id={"btnSubmit"} style={{maxHeight:'40px'}} disabled="disabled">
                            <span>{t('app.step.konfigAnfrage.sendButtonSent')}</span>
                        </ColorButton4> :
                        <ColorButton4 className={"btn-send"} type={"submit"} id={"btnSubmit"} style={{maxHeight:'40px'}}>
                            <span>{t('app.step.konfigAnfrage.sendButton')}</span>
                        </ColorButton4>
                    }
                </div>
                </form>
            </div>
        </div> : null}
        {/*Elbridge*/}
        {isMyJung && ['de', 'at'].includes(language) ? <div className="fs-container mt-15 p0 last-banner">
            <div className={"col-12"}>
                <div className={"lastbanner"}>
                    <img className={"bannerimage"} alt="people" src={peopleImg} width="435px" />
                    <div style={{display:'flex', flexDirection: 'column'}}>
                        <div className={"form"}>
                            <div className={"section-title"}>{t('app.step.elbridge.title')}</div>
                            <div className={"section-text"}>{t('app.step.elbridge.description')}</div>
                            <div className={"form-row"} style={{alignItems: 'flex-end', flexDirection: 'column'}}>
                                <ColorButton42 className={"btn-send"} onClick={sendElbridge}>
                                    <span>{t('app.step.elbridge.search')}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="30" viewBox="0 0 33 30">
                                        <g transform="translate(1226 294.034) rotate(180)">
                                            <rect width="33" height="30" transform="translate(1193 264.034)" fill="transparent"/>
                                            <path d="M12.859,8.077l.679.679a.731.731,0,0,1,0,1.037L7.6,15.738a.731.731,0,0,1-1.037,0L.613,9.792a.731.731,0,0,1,0-1.037l.679-.679a.735.735,0,0,1,1.049.012l3.511,3.686V2.984a.732.732,0,0,1,.734-.734h.979a.732.732,0,0,1,.734.734v8.79L11.81,8.089A.73.73,0,0,1,12.859,8.077Z" transform="translate(1202.715 269.608)" fill="#fff"/>
                                        </g>
                                    </svg>
                                </ColorButton42>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> : null}
        {showProjektboerse && language === 'de' ? <>
            <div className="fs-container mt-15 ptb-25" id={"boersecontainer"} style={{position:'relative'}}>
                <div className="padding-container p40" style={{paddingLeft:'70px !important'}}>
                    <div className="row planungscode">
                        <div className="col-6" style={{display: 'flex', flexDirection: 'column'}}>
                            <div className="section-title">JUNG Fachpartner finden Ihr Projekt auf <a style={{color:'var(--blueColor)',textDecoration:'none'}} href={"https://projektbörse.de/"} target={"_blank"} rel="noreferrer">projektbörse.de</a></div>
                            <div className="section-text mb-15">Bei <a style={{color:'var(--blueColor)',textDecoration:'none'}} href={"https://projektbörse.de/"} target={"_blank"} rel="noreferrer">projektbörse.de</a> finden JUNG Fachpartner in Ihrer Nähe das Projekt. Interessierte Fachbetriebe treten mit Ihnen in Kontakt für eine Projektbesprechung und Angebotserstellung.</div>
                            <div className={"exportButtons"}>
                                {<BtnProjektBoerse onClick={(e) => toggleProjektboerse(e)}>Projekt einstellen</BtnProjektBoerse>}
                            </div>
                        </div>
                        <div className="col-6" style={{paddingLeft: '20%'}}>
                            <img src={boerseImg} height="100%" style={{position:'absolute',top:'0',right:'0',height:'100%',width:'auto'}} alt={""} />
                        </div>
                    </div>
                </div>
            </div>
        </>: null}
        {showProjektboerse && language === 'de' ? <>
            <Popover id="boersePopover" open={boerseOpen} anchorEl={boerseElement} onClose={handleBoerseClose}
                     anchorOrigin={{
                         vertical: 'center',
                         horizontal: 'center',
                     }}
                     style={{maxWidth: '100%', width: '100%', backgroundColor: 'rgba(255, 255, 255, 0.75)'}}
                     className={boersePage === 2 ? "succeeded" : ""}
            >
                <div className={"popoverContainer"} style={{position: 'unset'}}>
                    <div className={"popoverHeader"}>
                        <div className={"images"}>
                            <img src={jungLogo} className={"left"} alt={""} />
                            <img src={boerseLogox} className={"left"} height="35" style={{margin: "0", maxHeight: '20px'}} alt={""} />
                            <img src={boerseLogo2} className={"right"} alt={""} />
                        </div>
                        <a href="#" onClick={handleBoerseClose} style={{color: 'var(--blueColor)'}}><CloseIcon /></a>
                    </div>
                    {boersePage === 1 ? <div className={"page-1"}>
                        <p className={"title-pb"}>Ihr JUNG HOME-Projekt: Vermittlung leicht gemacht</p>
                        <p>Projektbörse.de präsentiert Ihre JUNG HOME-Planung Elektroinstallateuren in Ihrer Umgebung und koordiniert einen Besichtigungstermin für eine ausführliche Projektbesprechung und komplette Angebotserstellung. So bringen wir Ihr smartes Zuhause einen Schritt näher!</p>
                        <input type="text" disabled="disabled" value={project.projectName !== '' ? project.projectName : project.name} className={"noform"} style={{marginTop: '5px'}} />
                        <form id={"boerseForm"} action={"/"} method={"post"} onSubmit={handleBoerseSubmit}>
                            <p className={"title-pb"}>E-Mailadresse</p>
                            <p>Sobald sich ein Elektroinstallateur für Ihr Projekt interessiert, werden Sie ausschließlich per E-Mail informiert mit einem Terminvorschlag des Handweriers.</p>
                            <input type="text" id={"kontaktEmail"} name={"kontaktEmail"} required={"required"} placeholder={"E-Mailadresse*"} style={{marginTop: '5px'}} />
                            <input type="text" id={"kontaktEmailRepeat"} name={"kontaktEmailRepeat"} required={"required"} placeholder={"E-Mailadresse wiederholen*"} style={{marginTop: '5px', marginBottom: '5px !important'}} autoComplete={"off"}/>
                            <div className="error" id={"kontaktEmail_error"}></div>
                            <p className={"title-pb"}>Kontaktdaten / Projektort</p>
                            <p>Diese Daten werden ausschließlich genutzt, um Ihr Projekt Handwerkern in Ihrer Nähe anzubieten. Und einem interessierten Handwerker die Kontaktaufnahme zu ermöglichen.</p>
                            <div className={"radios"} id={"kontaktAnrede"}>
                                <label><input type="radio" name={"gender[]"} value={"Herr"} required={"required"} /> Herr</label>
                                <label><input type="radio" name={"gender[]"} value={"Frau"} required={"required"} /> Frau</label>
                                <label><input type="radio" name={"gender[]"} value={"Divers"} required={"required"} /> Divers</label>
                            </div>
                            <div className="error" id={"kontaktAnrede_error"}></div>
                            <input className={"fields"} type="text" id={"kontaktVorname"} name={"kontaktVorname"} required={"required"} placeholder={"Vorname*"} />
                            <div className="error" id={"kontaktVorname_error"}></div>
                            <input className={"fields"} type="text" id={"kontaktNachname"} name={"kontaktNachname"} required={"required"} placeholder={"Name*"} />
                            <div className="error" id={"kontaktNachname_error"}></div>
                            <input className={"fields"} type="text" id={"kontaktStrasse"} name={"kontaktStrasse"} required={"required"} placeholder={"Straße*"} />
                            <div className="error" id={"kontaktStrasse_error"}></div>
                            <input className={"fields"} type="text" id={"kontaktHausnummer"} name={"kontaktHausnummer"} required={"required"} placeholder={"Hausnummer*"} />
                            <div className="error" id={"kontaktHausnummer_error"}></div>
                            <input className={"fields"} type="text" id={"kontaktPlz"} name={"kontaktPlz"} required={"required"} placeholder={"PLZ*"} />
                            <div className="error" id={"kontaktPlz_error"}></div>
                            <input className={"fields"} type="text" id={"kontaktOrt"} name={"kontaktOrt"} required={"required"} placeholder={"Ort*"} />
                            <div className="error" id={"kontaktOrt_error"}></div>
                            <label className={"toggler"}>
                                <input type="checkbox" value={"projektort_abweichend"} onChange={(e) => toggleProjektort(e)} name={"differentAddress"} />
                                (Abweichenden Projektort eingeben)
                            </label>
                            {projektOrt ?
                                <div className={"projektort"}>
                                    <input className={"fields"} type="text" id={"strasse"} name={"strasse"} required={"required"} placeholder={"Straße*"} />
                                    <div className="error" id={"strasse_error"}></div>
                                    <input className={"fields"} type="text" id={"hausnummer"} name={"hausnummer"} required={"required"} placeholder={"Hausnummer*"} />
                                    <div className="error" id={"hausnummer_error"}></div>
                                    <input className={"fields"} type="text" id={"plz"} name={"plz"} required={"required"} placeholder={"PLZ*"} />
                                    <div className="error" id={"plz_error"}></div>
                                    <input className={"fields"} type="text" id={"ort"} name={"ort"} required={"required"} placeholder={"Ort*"} />
                                    <div className="error" id={"ort_error"}></div>
                                </div>
                                : null}
                            <label className={"checkers"}>
                                <input type="checkbox" value="1" name={"accepted_agb"} required={"required"} />
                                <div>Mit meiner Projektübersendung akzeptiere ich die <a href={"https://qm.xn--projektbrse-yfb.de/nutzungsbedingungen"} target={"_blank"} rel="noreferrer">Nutzungsbedingungen</a> von projektbörse.de</div>
                            </label>
                            <label className={"checkers"}>
                                <input type="checkbox" value="1" name={"accepted_datenschutz"} required={"required"} />
                                <div>Ich akzeptiere die <a href={"https://qm.xn--projektbrse-yfb.de/datenschutz"} target={"_blank"} rel="noreferrer">Datenschutzbestimmungen</a></div>
                            </label>
                            <p></p>
                            <p>Überprüfen Sie Ihre Angaben und starten Sie die Vermittlung Ihres Projektes auf projektbörse.de</p>
                        </form>
                    </div> : null}
                    {boersePage === 2 ? <div className={"page-2"}>
                        <div className={"title-pb2"}>
                            <p className={"title"} style={{textAlign: 'center'}}>Ihr Projekt ist auf dem Weg!</p>
                            <img src={page2Checker} height={"80"} alt={""} style={{margin: "10px auto 30px"}} />
                            <p className={"subtitle"}>Ihr Vorhaben wird jetzt Elektroinstallateuren in Ihrer Region angeboten. Wir drücken die Daumen, dass sich schon bald ein Handwerker bei Ihnen per E-Mail meldet.</p>
                        </div>
                        <div className={"table"} style={{display: 'none'}}>
                            <div className={"row underlined header"}>
                                <img src={boerseLogo} alt={"logo"} />
                                <p>Angebotsanfrage</p>
                            </div>
                            <div className={"row withChecker"}>
                                <img src={boerseCircleCheck} alt={""} className={"checkerImg"}  />
                                <p><strong>Projekt an projektbörse.de übermittelt</strong><br/>{boerseDatum}</p>
                            </div>
                            <div className={"row withChecker"}>
                                <img src={boerseCircle} alt={""} className={"checkerImg"} />
                                <p>Projekt reserviert von Handwerker</p>
                            </div>
                            <div className={"row withChecker"}>
                                <img src={boerseCircle} alt={""} className={"checkerImg"} />
                                <p>Sichtungstermin-Vereinbarung</p>
                            </div>
                            <div className={"row withChecker underlined"}>
                                <img src={boerseCircle} alt={""} className={"checkerImg"} />
                                <p>Projekt vermittelt</p>
                            </div>
                        </div>
                        <div className={"pb-table"}>
                            <div className={"status"}>
                                <div className={"line1"}>Status</div>
                                <div className={"line2"}>Der Projektsteckbrief wurde gesendet.</div>
                            </div>
                            <div className={"icons"}>
                                <img src={pb01} alt={""} />
                                <img src={pb02} alt={""} />
                                <img src={pb03} alt={""} />
                                <img src={pb04} alt={""} />
                            </div>
                            <div className={"status-text"}>
                                <div className={"line1"}>Nächter Schritt: E-Mailbenachrichtigung bestätigen.</div>
                                <div className={"line2"}>Sie erhalten in Kürze eine E-Mail von projektbörse.de. Diese müssten Sie bitte bestätigen, damit Ihr Projekt veröffentlicht wird.</div>
                            </div>
                            <div className={"next-steps"}>
                                <div className={"title-pb3"}>
                                    <img src={arrow_down} alt={""} />
                                    <p>Weiterer Projektverlauf</p>
                                </div>
                                <div className={"step"}>
                                    <img src={iconStep1} alt={""} />
                                    <div className={"step-text"}>Projekt wurde veröffentlicht.</div>
                                </div>
                                <div className={"step-divider"}><img src={stepDivider} alt={""} /></div>
                                <div className={"step"}>
                                    <img src={iconStep2} alt={""} />
                                    <div className={"step-text"}>Sichtungstermin wurde gesendet.</div>
                                </div>
                                <div className={"step-divider"}><img src={stepDivider} alt={""} /></div>
                                <div className={"step"}>
                                    <img src={iconStep3} alt={""} />
                                    <div className={"step-text"}>Sichtungstermin wurde bestätigt.</div>
                                </div>
                                <div className={"step-divider"}><img src={stepDivider} alt={""} /></div>
                                <div className={"step"}>
                                    <img src={iconStep4} alt={""} />
                                    <div className={"step-text"}>Projektvermittlung ist beendet.</div>
                                </div>
                            </div>
                        </div>
                    </div> : null}
                    <div className={"popoverFooter"}>
                        {boersePage === 1 ? <BtnProjektBoerse2 onClick={(e) => sendBoerseForm(e)}>Absenden <img src={arrow_right} style={{marginLeft: '5px'}} alt={""} /></BtnProjektBoerse2>: null}
                        {/*{boersePage === 2 ? <BtnProjektBoerse onClick={(e) => handleBoerseClose(e)}>Schließen</BtnProjektBoerse>: null}*/}
                    </div>
                </div>
            </Popover>
        </> : null}
        <div className="pricebox-sticky-bottom">
            <PriceBox />
            {window.innerWidth < 800 ? <PriceBox justNotice={true} /> : null}
        </div>
        <Dialog
            open={sentDialogIsOpened}
            onClose={handleDialogClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description" color={"inherit"} style={{textAlign:'center',lineHeight:'2'}}
                                   dangerouslySetInnerHTML={{__html: t('app.step.konfigAnfrage.success')}}>
                </DialogContentText>
            </DialogContent>
            <DialogActions style={{justifyContent: "center"}}>
                <div onClick={handleDialogClose} color="primary"
                     className={"modalButton disagree"}>
                    {t('phone.button.close')}
                </div>
            </DialogActions>
        </Dialog>
        {/*{ showProjektboerse && language === 'de' ?*/}
            <Popover id="userInfoPopover" open={userInfoOpen} onClose={handleInfoClose}
                     anchorOrigin={{
                         vertical: 'center',
                         horizontal: 'center',
                     }}
                     style={{maxWidth: '100%', width: '100%', backgroundColor: 'rgba(255, 255, 255, 0.75)'}}
            >
                <div className={"popoverContainer"} style={{position: 'unset'}}>
                    <div className={"popoverHeader"} style={{position:'sticky',top:'0',background:'white',paddingTop:'15px',margin:'-30px',marginBottom:'5px'}}>
                        <div className={"images"}>
                            <img src={jungLogo} className={"center"} alt={""} />
                            <img src={boerseLogox} className={"left"} height="35" style={{margin: "0", maxHeight: '20px', display:'none'}} alt={""}/>
                            <img src={boerseLogo2} className={"right"} style={{display:'none'}} alt={""} />
                        </div>
                        <a href="" onClick={handleInfoClose} style={{color: 'var(--textColor)'}}><CloseIcon /></a>
                    </div>
                    {userInfoPage === 1 ?
                    <div class="projekt_properties_form" name="projekt_properties_form" method={"post"}>
                        <p className={"title-pb"} style={{color:'var(--textColor)',fontWeight:'100'}}>Transfer zum JUNG Projekt Manager</p>
                        <p>Projektdaten können hier für die weitere Bearbeitung und detaillierte Planung im JUNG<br/>Projekt Manager ergänzt werden. Die Angaben der Daten sind nicht verpflichtend.</p>
                        <div className="row">
                            <div className="col-5">
                                <label className="d-block required">Projektcode</label>
                                <input type="text" name="projekt_properties_form[projektcode]" className="w-100" disabled={"disabled"} value={prCode} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6 pr5">
                                <label className="d-block required" htmlFor="projekt_properties_form_projektname">Projektname</label>
                                <input type="text" id="projekt_properties_form_projektname" name="projekt_properties_form[projektname]"
                                       required="required" className="w-100" value={prname !== '' ? prname : ''} onChange={handleProjectNameChange} />
                            </div>
                            <div className="col-5 pl5">
                                <label className="d-block" htmlFor="projekt_properties_form_projektNr">Projekt-Nr.</label>
                                <input type="text" id="projekt_properties_form_projektNr" name="projekt_properties_form[projektNr]" maxLength="255" className="w-100" />
                            </div>
                            <div className="col-1" style={{paddingTop:'22px',paddingLeft:'15px',paddingRight:'0',maxWidth:'40px'}}>
                                {project.projectType === 'konventionell' ? <img src={jungSwitchLogo} width="40" alt={""} /> : null}
                                {project.projectType === 'knx' ? <img src={jungKnxLogo} width="40" alt={""} /> : null}
                                {project.projectType === 'home' ? <img src={jungHomeLogo} width="40" alt={""} /> : null}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">&nbsp;</div>
                        </div>
                        <div className="row">
                            <div className="col-12 titleCol">Ansprechpartner / Empfänger</div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-6" style={{position:'relative'}}>
                                        <label className="d-block" htmlFor="projekt_properties_form_anrede">Anrede</label>
                                        <select id="projekt_properties_form_anrede" name="projekt_properties_form[anrede]" rows="15" className="w-100 projekt-anrede">
                                            <option value="" selected="selected">Wählen</option>
                                            <option value="Herr">Herr</option>
                                            <option value="Frau">Frau</option>
                                            <option value="Neutrale Anrede">Neutrale Anrede</option>
                                        </select>
                                        <div className="arrow down"></div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <label className="d-block" htmlFor="projekt_properties_form_vorname">Vorname</label>
                                        <input type="text" id="projekt_properties_form_vorname" name="projekt_properties_form[vorname]" maxLength="255" className="w-100" />
                                    </div>
                                    <div className="col-6" style={{paddingLeft:'15px',paddingRight:'0'}}>
                                        <label className="d-block" htmlFor="projekt_properties_form_name">Name</label>
                                        <input type="text" id="projekt_properties_form_name" name="projekt_properties_form[name]" maxLength="255" className="w-100" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <label className="d-block" htmlFor="projekt_properties_form_firma">Firma</label>
                                        <input type="text" id="projekt_properties_form_firma" name="projekt_properties_form[firma]" className="w-100" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <label className="d-block" htmlFor="projekt_properties_form_strasse">Straße</label>
                                        <input type="text" id="projekt_properties_form_strasse" name="projekt_properties_form[strasse]" maxLength="255" className="w-100" />
                                    </div>
                                    <div className="col-6" style={{paddingLeft:'15px',paddingRight:'0'}}>
                                        <label className="d-block" htmlFor="projekt_properties_form_strNr">Nr.</label>
                                        <input type="text" id="projekt_properties_form_strNr" name="projekt_properties_form[strNr]" maxLength="15" className="w-100" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <label className="d-block" htmlFor="projekt_properties_form_plz">PLZ</label>
                                        <input type="text" id="projekt_properties_form_plz" name="projekt_properties_form[plz]" maxLength="10" className="w-100" />
                                    </div>
                                    <div className="col-6" style={{paddingLeft:'15px',paddingRight:'0'}}>
                                        <label className="d-block" htmlFor="projekt_properties_form_ort">Ort</label>
                                        <input type="text" id="projekt_properties_form_ort" name="projekt_properties_form[ort]" maxLength="255" className="w-100" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*<div className="row">*/}
                        {/*    <div className="col-12 titleCol">Projektbeschreibung</div>*/}
                        {/*</div>*/}
                        {/*<div className="row">*/}
                        {/*    <div className="col-12">*/}
                        {/*        <textarea id="projekt_properties_form_projektBeschreibung" name="projekt_properties_form[projektBeschreibung]" rows="10" className="w-100" placeholder="Beschreibung"></textarea>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>
                        :null}
                    {userInfoPage === 1 ?
                    <div className={"popoverFooter"} style={{display:'flex',alignItems:'center',flexDirection:'row'}}>
                        <BtnProjektBoerse3 onClick={(e) => handleInfoClose()} style={{marginLeft:'auto'}}>Abbrechen</BtnProjektBoerse3>
                        <BtnProjektBoerse3 className="active" onClick={(e) => saveUserInfo(e)}>Zum Projektmanager wechseln</BtnProjektBoerse3>
                        {/*{boersePage === 2 ? <BtnProjektBoerse onClick={(e) => handleBoerseClose(e)}>Schließen</BtnProjektBoerse>: null}*/}
                    </div> : null}
                    {userInfoPage === 2 ?
                    <div className="projekt_properties_form">
                        <div className="row">
                            <div className="col-12">
                                <label><strong>Ihre Eingaben wurden erfolgreich gespeichert.</strong></label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <p>Somit sparen Sie wertvolle Arbeitszeit bei der Projektanlage und Fortführung des Projektes im JUNG Projekt Manager.</p>
                            </div>
                        </div>
                    </div>
                        :null}
                    {userInfoPage === 2 ?
                    <div className={"popoverFooter"}>
                        <BtnProjektBoerse3 onClick={(e) => handleInfoClose(e)}>Schließen</BtnProjektBoerse3>
                    </div> : null}
                </div>
            </Popover>
        {/*: null }*/}
    </>;
}
